const globalVar = {
  install: function (Vue, options) {
    const main = new Vue({
      data: function () {
        return {
          targetJobChangeIds: [
            "rirekisho_job_change",
            "rirekisho_ai_career",
            "rirekisho_job_change2",
            "rirekisho_job_change_old",
            "rirekisho_single",
            "rirekisho_nophoto_double",
            "rirekisho_nophoto"
          ],
          qmailRirekishoHtml: '',
          deviceToken: '',
          dn_flag: 'dn',
          isYagiPrime: false,
          isYagiPrimeCancel: false,
          isYagiPrimeQuickmailcount: 0,
          isShogai: false,
          in_app_payments: true,
          google_ads_tag: [{ 'id': 'jobs919_mail', 'ptype': 5 },
          { 'id': 'jobs919_mail', 'ptype': 1 },
          { 'id': 'jobs919_mail', 'ptype': 2 },
          { 'id': 'krasys_mail', 'ptype': 1 },
          { 'id': 'hrcareer_mail', 'ptype': 5 },
          { 'id': 'hrcareer_mail', 'ptype': 6 },
          { 'id': 'hrcareer_mail', 'ptype': 7 },
          { 'id': 'hrcareer_mail', 'ptype': 8 },
          { 'id': 'hrcareer_mail', 'ptype': 9 },
          { 'id': 'hrcareer_mail', 'ptype': 10 },
          { 'id': 'hrcareer_mail', 'ptype': 11 },
          { 'id': 'hrcareer_mail', 'ptype': 12 },
          { 'id': 'hrcareer_mail', 'ptype': 15 },
          { 'id': 'recree_mail', 'ptype': 2 },
          { 'id': 'recree_mail', 'ptype': 3 },
          { 'id': 'recree_mail', 'ptype': 4 },
          { 'id': 'hitotech_admin', 'ptype': 1 },
          { 'id': 'hitotech_admin', 'ptype': 2 },
          { 'id': 'hitotech_admin', 'ptype': 3 },
          { 'id': 'hitotech_admin', 'ptype': 4 },
          { 'id': 'sms_admin', 'ptype': 1 },
          { 'id': 'sms_admin_eiyoshi', 'ptype': 2 },
          { 'id': 'sms_admin_hoiku', 'ptype': 3 },
          { 'id': 'hitoshia_admin', 'ptype': 3 },
          { 'id': 'hitoshia_admin', 'ptype': 4 },
          { 'id': 'pleiades_mail', 'ptype': 2 },
          { 'id': 'pleiades_mail', 'ptype': 10 },
          { 'id': 'pleiades_mail', 'ptype': 18 },
          { 'id': 'pleiades_mail', 'ptype': 11 },
          { 'id': 'pleiades_mail', 'ptype': 12 },
          { 'id': 'pleiades_mail', 'ptype': 13 },
          { 'id': 'pleiades_mail', 'ptype': 16 },
          { 'id': 'pleiades_mail', 'ptype': 17 },
          { 'id': 'neocareer_admin', 'ptype': 1 },
          { 'id': 'neocareer_admin', 'ptype': 2 },
          { 'id': 'peacekaigo_mail', 'ptype': 2 },
          { 'id': 'peacekaigo_mail', 'ptype': 4 }
          ],
          joblistKeyword20240415: ['施工管理', '看護師', '薬剤師', '作業療法士', '理学療法士', '言語聴覚士', '視能訓練士', '保育士', '歯科衛生士', '介護職', 'ヘルパー', '栄養士', '歯科助手', '販促物の製作業務', '福岡私立精華女子高等学校', '畜産農家', 'Webマーケティング', 'ペット業界', '医療法人社団三木会 花まる歯科クリニック 入社', 'CAD製図', 'アコースティックギター演奏', 'ビジネス工科専門学校', 'webライター', '高齢の母親と一緒に暮らしているため、転勤は避けたい', '高速道路', 'スポーツ国際開発', '写植', '岡山商科大学', '宿泊業', '残業', 'ダンスインストラクター', '回送', 'セールスドライバー', 'バスケ', '教育福祉', '熊本市立帯山中学校卒業', '鈑金塗装', '3Dデザイン', 'データ整理', '自動車関連の仕事', 'グランドハンドリング', '接客販売業', '接客サービス業', '電話受付', '在宅の仕事', '中古車販売', 'マーケティングリサーチ', '総務労務', '配送業務', '鍼灸', 'パン職人', '工業高校', 'ITサポート', 'ヤマト運輸', '郵便局', '化学工学', 'キッチンスタッフ', 'ファッションビジネス', '日本語学科', '自然環境専門高校入学', '給与計算', 'パソコン操作', '塾講師', '猫カフェ', '接客経験', '不動産事務', '溶接', 'ライター', '不動産営業', '通関士', 'アパレル販売', '幼児教育', '保険営業', '在宅勤務', '英語教育', '運輸', 'パソコン', '社会福祉士', '法学', '保険', '法律事務所', '電気工事士', '大学', '電気工事', 'UI', '教育', '営業事務', '製造業', '一般事務', '旅行', '医療事務', '営業職', '教員', '経済学部', '接客販売', '医療', 'マネジメント', '自動車', 'IT', '日本語教師', 'マーケティング', '経理', '医薬', 'ホテル', '調理師', '総務', 'フォークリフト', '飲食業', '建設', '軽作業', '農業', 'ゲーム', '工場', '未経験', '企画', 'インテリア', '役所', '化学', 'デザイン', '美容師', '広告', '美容', '営業', '土木', '警備', '管理', '事務', '飲食', '事務職', 'コールセンター', 'エンジニア', 'インターネット', 'SE', 'NPO', '福祉', '映像', '学校法人', '介護', '講師', '医師', '接客', '不動産', '接客業', '看護', '受付', '交通', '公務員', '動物', 'サービス', '製造', '配送', '販売', 'データ入力', 'アパレル', 'スポーツ', '印刷', '制作', '人事', 'クリニック', '開発', '保育', 'サポート', '機械', '運営', '食品', 'プラスチック成形', '土日勤務', '運動経験', 'データ検査', 'アニメ声優', '東大阪市立日新高等学校', '土木施工管理', '情報環境科', '洋服販売', 'エリアマネジャー', 'ビジネススクール', '中古ジュエリー販売', '岡山', 'お寿司の製造', '期間工', '教育関係', '接客応対', '舞台設備工事', '倉庫オペレータ', '会計税務アシスタント', '売り場づくり', '保育士補助', 'ECサイトの運営業務', '障害者移動支援', 'バル', '小学校通訳', '経理総務事務', 'アミューズメントパーク', '材料技術', '陸送業務', 'IT職種', '総合受付業務', '損保事務', 'ITインフラエンジニア', '医療技術短期大学部', '保育園看護師', '軽貨物運送事業', '漫画家', 'エアジャパン', '成田国際空港', 'アトラクションメンテナンス', 'オンライン決済代行業', '総務部', '建設用軽仮設機材', '子育て支援員', '回収車', '尾瀬高等学校', '洗車', 'フィギュア買い取り', '広島県立安西高等学校', '日立エレベーターサービス株式会社', '大型ダンプ運転手', '損害保険調査', 'プロダクトデザイナー', '熊本県立八代高等学校', 'コンタクトセンター', '物流倉庫内のクール便の仕分け作業', '鮮魚部門', '事務調達職', '千葉県立市原高等学校', '日本化粧品検定2級合格', '千葉県立成田北高等学校', '美容外科 受付 サポート 事務', '財務事務', '医療IT業界', '金属プレス', '営業経験', '土地仕入業務', '医療・保育・介護', '事務リーダー', '人材営業', 'MR', '文章構成', '子供英語講師', '筋力トレーニング', '大型自動車免許', '生産技術業務', '化学生命工学', 'スフォリアテッラ専門店', 'トラブル解決', 'ネットショップ', '事務一般', '短大', '大阪大学人間科学部人間科学科', '製造ライン', 'アプリケーション開発', '石油化学プラント オペレーター', 'Web', '医学技術', '福祉心理', '法務事務', '技術専門', '競走馬', '郵便配達', '飲食サービス', '提案営業', '茨城県立ルネサンス高等学校', '製造工場', 'インテリア業界', '弁護士', '成田空港地上職', '広島市立舟入高等学校', '大学事務員', 'リユース業', '文化財学科', '短期アルバイト', 'EC店鋪運営', '医療サービス業', '医師事務作業補助者', '製袋機オペレーター', '物流企画', '給排水処理設備の運転管理', '通信', '物流倉庫スタッフ', '第二種電気工事士', 'カバーディーラー', '国際英語学科', 'アトラクション運営', '横浜駅周辺', '送電線業界の建設土木', 'データマネージャー', '美術科', '介護施設', '総合事務', '東洋大学', '食物調理', '理学療法', '会計・税務知識', '生活支援員', '旅行業界', '生活相談員', 'パソコン作業', '土木建設業', 'ロボット工学', '施工管理アシスタント', '食品栄養学', '教育支援', '情報専門学校', '設備メンテナンス', 'PC業務', '買取営業', '介護事務', '医療従事者', 'インテリア・住宅関連', '工事現場管理', 'ネットワーク', '訪問介護', '不動産管理', '医療機関', '配達ドライバー', 'メンテナンス', '日本の仕事', '航空貨物', 'インサイドセールス', 'サッカー', 'システムエンジニア・プログラマ', '佐賀県立佐賀農業高等学校', '国際関係学', '社長秘書', '英語力', 'カラオケ', '総務職', '副業', '文学', '経営コンサルタント', '喫茶店', '総務経理事務', 'キッチン', '人材紹介', '工業化学', '病棟クラーク', '指導員', 'テクニカルスタッフ', '音楽講師', '倉庫内作業', 'デンソー', '組立', 'セレクトショップ', '障がい者支援', '警備員', '国際営業', '美容室受付', '心理カウンセリング', '鮮魚', '文学部', '倉庫', '営業サポート', '普通自動車第一種運転免許取得', '外国語学部', 'ビジネスマネジメント', '受付兼助手', '医学部', '映像編集', '建築設備点検', '鉄道', '経営学科', '英会話講師', '営業事務職', '人事職', 'デジタルマーケティング', 'SNSマーケティング', '獣医', '自衛隊', '養護教諭', '短期バイト', 'Web開発', 'ホテル業界', '事務・秘書・受付', '看護助手', 'トラック運転手', '国際経済学', 'ルート営業', 'webデザイナー', '調剤薬局事務', '金融業務', '法政大学', '携帯電話販売', 'プログラマー', '設備管理', '仕分け', 'ゲーム業界', '臨床検査技師', 'CADオペレーター', 'WEBデザイン', '陸上自衛隊', '動物看護', '製造業務', '神社', '経理業務', '倉庫作業', '地理学', '医療機器', '事務業務', '物流業', 'システムエンジニア', '建築設計', '英米文学', '製造オペレーター', '歯科技工士', '高校生', '司書', '日本文学', '歯科', '国際経営', 'ITエンジニア', 'カウンセラー', '運転', '人材コーディネーター', '機械工学', '運送業', 'ファッションデザイン', '新卒', 'インフラエンジニア', '製造職', '工場勤務', '製菓', '販売業務', '経営学部', '日本文化', '整備士', '料理', '法人営業', 'パティシエ', 'DTPオペレーター', '法務', '自動車整備士', '早稲田大学', '飲食店', '医療法人', '経理事務', '事務作業', '倉庫管理', '総務事務', 'システム開発', 'ものづくり', '受付業務', '調剤事務', '介護福祉士', 'グラフィックデザイン', '情報処理', '調理', '財務', '自動車販売', 'ドライバー', '接客業務', 'データ分析', '食品製造', '経営学', '管理栄養士', '士業', 'ゲーム開発', '品質管理', '社会福祉', '銀行', '法律', '生産管理', 'IT業界', '受付事務', '販売員', '建設業', '不動産業', '心理学', 'レジャー', '大学卒業後', 'コンサルタント', '翻訳', '物流', '通訳', '販売職', '編集', '工事', '経済学', '会計', 'デザイナー', 'プログラミング', '理容', '音楽', 'ブライダル', '建築', '映画', 'マネージャー', '点検', '設計', '化粧品', 'エステ', 'フード', '清掃', '金融', 'イベント', 'プロジェクトマネージャー', 'クリエイティブ'],
          joblistKeyword: ['工場', 'フォークリフト', '軽作業', '清掃', '製造', '出荷', 'ピッキング', 'ラベル貼り', '箱詰め', '溶接', '研磨', '梱包', '検品', '施工管理', '看護師', '薬剤師', '作業療法士', '理学療法士', '言語聴覚士', '視能訓練士', '保育士', '歯科衛生士', '介護職', 'ヘルパー', '栄養士', '歯科助手', '販促物の製作業務', '福岡私立精華女子高等学校', '畜産農家', 'Webマーケティング', 'ペット業界', 'CAD製図', 'アコースティックギター演奏', 'ビジネス工科専門学校', 'webライター', '高速道路', 'スポーツ国際開発', '写植', '岡山商科大学', '宿泊業', '残業', 'ダンスインストラクター', '回送', 'セールスドライバー', 'バスケ', '教育福祉', '熊本市立帯山中学校卒業', '鈑金塗装', '3Dデザイン', 'データ整理', '自動車関連の仕事', 'グランドハンドリング', '接客販売業', '接客サービス業', '電話受付', '在宅の仕事', '中古車販売', 'マーケティングリサーチ', '総務労務', '配送業務', '鍼灸', 'パン職人', '工業高校', 'ITサポート', 'ヤマト運輸', '郵便局', '化学工学', 'キッチンスタッフ', 'ファッションビジネス', '日本語学科', '自然環境専門高校入学', '給与計算', 'パソコン操作', '塾講師', '猫カフェ', '接客経験', '不動産事務', 'ライター', '不動産営業', '通関士', 'アパレル販売', '幼児教育', '保険営業', '在宅勤務', '英語教育', '運輸', 'パソコン', '社会福祉士', '法学', '保険', '法律事務所', '電気工事士', '大学', '電気工事', 'UI', '教育', '営業事務', '製造業', '一般事務', '旅行', '医療事務', '営業職', '教員', '経済学部', '接客販売', '医療', 'マネジメント', '自動車', 'IT', '日本語教師', 'マーケティング', '経理', '医薬', 'ホテル', '調理師', '総務', 'フォークリフト', '飲食業', '建設', '農業', 'ゲーム', '未経験', '企画', 'インテリア', '役所', '化学', 'デザイン', '美容師', '広告', '美容', '営業', '土木', '警備', '管理', '事務', '飲食', '事務職', 'コールセンター', 'エンジニア', 'インターネット', 'SE', 'NPO', '福祉', '映像', '学校法人', '介護', '講師', '医師', '接客', '不動産', '接客業', '看護', '受付', '交通', '公務員', '動物', 'サービス', '配送', '販売', 'データ入力', 'アパレル', 'スポーツ', '印刷', '制作', '人事', 'クリニック', '開発', '保育', 'サポート', '機械', '運営', '食品', 'プラスチック成形', '土日勤務', '運動経験', 'データ検査', 'アニメ声優', '東大阪市立日新高等学校', '土木施工管理', '情報環境科', '洋服販売', 'エリアマネジャー', 'ビジネススクール', '中古ジュエリー販売', '岡山', 'お寿司の製造', '期間工', '教育関係', '接客応対', '舞台設備工事', '倉庫オペレータ', '会計税務アシスタント', '売り場づくり', '保育士補助', 'ECサイトの運営業務', '障害者移動支援', 'バル', '小学校通訳', '経理総務事務', 'アミューズメントパーク', '材料技術', '陸送業務', 'IT職種', '総合受付業務', '損保事務', 'ITインフラエンジニア', '医療技術短期大学部', '保育園看護師', '軽貨物運送事業', '漫画家', 'エアジャパン', '成田国際空港', 'アトラクションメンテナンス', 'オンライン決済代行業', '総務部', '建設用軽仮設機材', '子育て支援員', '回収車', '尾瀬高等学校', '洗車', 'フィギュア買い取り', '広島県立安西高等学校', '日立エレベーターサービス株式会社', '大型ダンプ運転手', '損害保険調査', 'プロダクトデザイナー', '熊本県立八代高等学校', 'コンタクトセンター', '物流倉庫内のクール便の仕分け作業', '鮮魚部門', '事務調達職', '千葉県立市原高等学校', '日本化粧品検定2級合格', '千葉県立成田北高等学校', '美容外科 受付 サポート 事務', '財務事務', '医療IT業界', '金属プレス', '営業経験', '土地仕入業務', '医療・保育・介護', '事務リーダー', '人材営業', 'MR', '文章構成', '子供英語講師', '筋力トレーニング', '大型自動車免許', '生産技術業務', '化学生命工学', 'スフォリアテッラ専門店', 'トラブル解決', 'ネットショップ', '事務一般', '短大', '大阪大学人間科学部人間科学科', '製造ライン', 'アプリケーション開発', '石油化学プラント オペレーター', 'Web', '医学技術', '福祉心理', '法務事務', '技術専門', '競走馬', '郵便配達', '飲食サービス', '提案営業', '茨城県立ルネサンス高等学校', '製造工場', 'インテリア業界', '弁護士', '成田空港地上職', '広島市立舟入高等学校', '大学事務員', 'リユース業', '文化財学科', '短期アルバイト', 'EC店鋪運営', '医療サービス業', '医師事務作業補助者', '製袋機オペレーター', '物流企画', '給排水処理設備の運転管理', '通信', '物流倉庫スタッフ', '第二種電気工事士', 'カバーディーラー', '国際英語学科', 'アトラクション運営', '横浜駅周辺', '送電線業界の建設土木', 'データマネージャー', '美術科', '介護施設', '総合事務', '東洋大学', '食物調理', '理学療法', '会計・税務知識', '生活支援員', '旅行業界', '生活相談員', 'パソコン作業', '土木建設業', 'ロボット工学', '施工管理アシスタント', '食品栄養学', '教育支援', '情報専門学校', '設備メンテナンス', 'PC業務', '買取営業', '介護事務', '医療従事者', 'インテリア・住宅関連', '工事現場管理', 'ネットワーク', '訪問介護', '不動産管理', '医療機関', '配達ドライバー', 'メンテナンス', '日本の仕事', '航空貨物', 'インサイドセールス', 'サッカー', 'システムエンジニア・プログラマ', '佐賀県立佐賀農業高等学校', '国際関係学', '社長秘書', '英語力', 'カラオケ', '総務職', '副業', '文学', '経営コンサルタント', '喫茶店', '総務経理事務', 'キッチン', '人材紹介', '工業化学', '病棟クラーク', '指導員', 'テクニカルスタッフ', '音楽講師', '倉庫内作業', 'デンソー', '組立', 'セレクトショップ', '障がい者支援', '警備員', '国際営業', '美容室受付', '心理カウンセリング', '鮮魚', '文学部', '倉庫', '営業サポート', '普通自動車第一種運転免許取得', '外国語学部', 'ビジネスマネジメント', '受付兼助手', '医学部', '映像編集', '建築設備点検', '鉄道', '経営学科', '英会話講師', '営業事務職', '人事職', 'デジタルマーケティング', 'SNSマーケティング', '獣医', '自衛隊', '養護教諭', '短期バイト', 'Web開発', 'ホテル業界', '事務・秘書・受付', '看護助手', 'トラック運転手', '国際経済学', 'ルート営業', 'webデザイナー', '調剤薬局事務', '金融業務', '法政大学', '携帯電話販売', 'プログラマー', '設備管理', '仕分け', 'ゲーム業界', '臨床検査技師', 'CADオペレーター', 'WEBデザイン', '陸上自衛隊', '動物看護', '製造業務', '神社', '経理業務', '倉庫作業', '地理学', '医療機器', '事務業務', '物流業', 'システムエンジニア', '建築設計', '英米文学', '製造オペレーター', '歯科技工士', '高校生', '司書', '日本文学', '歯科', '国際経営', 'ITエンジニア', 'カウンセラー', '運転', '人材コーディネーター', '機械工学', '運送業', 'ファッションデザイン', '新卒', 'インフラエンジニア', '製造職', '製菓', '販売業務', '経営学部', '日本文化', '整備士', '料理', '法人営業', 'パティシエ', 'DTPオペレーター', '法務', '自動車整備士', '早稲田大学', '飲食店', '医療法人', '経理事務', '事務作業', '倉庫管理', '総務事務', 'システム開発', 'ものづくり', '受付業務', '調剤事務', '介護福祉士', 'グラフィックデザイン', '情報処理', '調理', '財務', '自動車販売', 'ドライバー', '接客業務', 'データ分析', '食品製造', '経営学', '管理栄養士', '士業', 'ゲーム開発', '品質管理', '社会福祉', '銀行', '法律', '生産管理', 'IT業界', '受付事務', '販売員', '建設業', '不動産業', '心理学', 'レジャー', '大学卒業後', 'コンサルタント', '翻訳', '物流', '通訳', '販売職', '編集', '工事', '経済学', '会計', 'デザイナー', 'プログラミング', '理容', '音楽', 'ブライダル', '建築', '映画', 'マネージャー', '点検', '設計', '化粧品', 'エステ', 'フード', '金融', 'イベント', 'プロジェクトマネージャー', 'クリエイティブ'],
          joblistPrefs: ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県', '海外']
        }
      },
      computed: {
      },
      methods: {
        isJobChangeFormat: function (_id) {
          return this.targetJobChangeIds.includes(_id)
        },
        isJobChangeShokumukeirekiFormat: function (_id) {
          return this.targetJobChangeIds.includes(_id) || _id.includes('shokumukeirekisho')
        },
        eventTag: function () {
          // alert('pdf_' + this.dn_flag + '_rt_completed')
          this.invokeNative('pdf_' + this.dn_flag + '_rt_completed')
        },
        invokeNative: function (_id) {
          console.error(_id)
          if (this.$site.appFlag == 'b' || true) {
            try {
              MessageInvoker.postMessage(_id);
            } catch (error) {
              console.warn(`Error occurred while calling postMessage: ${error.message}`);
            }
          }
        },
        googleAdsTagCheck: function (client_id, permission_type) {
          console.error("googleAdsTagCheck")
          // google_ads_tag のリストを検索して一致する項目を探す
          const matchedTags = this.google_ads_tag.filter(tag => {
            return tag.id === client_id && tag.ptype === permission_type;
          })
          // 結果に応じた処理
          if (matchedTags.length > 0) {
            console.log("一致するタグが見つかりました:", matchedTags)
            return true
          } else {
            console.log("一致するタグが見つかりません")
            return false
          }

        },
        keywordCheck: function (formatId, formatData, keyword) {
          let _check = false
          if (formatId == "shokumukeirekisho") {
            return false
          }
          for (let key in formatData.educationalHistories) {
            // 見出し
            let item = formatData.educationalHistories[key]
            if (item.description && item.description.indexOf(keyword) >= 0) {
              _check = true
            }
          }
          for (let key in formatData.jobHistories) {
            // 見出し
            let item = formatData.jobHistories[key]
            if (item.description && item.description.indexOf(keyword) >= 0) {
              _check = true
            }
          }
          for (let key in formatData.licenseHistories) {
            // 見出し
            let item = formatData.licenseHistories[key]
            if (item.description && item.description.indexOf(keyword) >= 0) {
              _check = true
            }
          }
          return _check
        },
        keywordCheckOnlyLicense: function (formatId, formatData, keyword) {
          let _check = false
          if (formatId == "shokumukeirekisho") {
            return false
          }
          for (let key in formatData.licenseHistories) {
            // 見出し
            let item = formatData.licenseHistories[key]
            if (item.description && item.description.indexOf(keyword) >= 0) {
              _check = true
            }
          }
          return _check
        },
        keywordCheck2: function (formatId, formatData, keyword) {
          let _check = false
          if (formatId == "shokumukeirekisho") {
            return false
          }
          for (let key in formatData.educationalHistories) {
            // 見出し
            let item = formatData.educationalHistories[key]
            if (item.description.indexOf(keyword) >= 0) {
              _check = true
            }
          }
          for (let key in formatData.licenseHistories) {
            // 見出し
            let item = formatData.licenseHistories[key]
            if (item.description.indexOf(keyword) >= 0) {
              _check = true
            }
          }
          return _check
        },
        keywordCheck3: function (formatData, keyword) {
          let _check = false

          if (formatData.prMessage && formatData.prMessage.indexOf(keyword) >= 0) {
            _check = true
          }
          if (formatData.jobSummary && formatData.jobSummary.indexOf(keyword) >= 0) {
            _check = true
          }
          if (formatData.jobHistories) {
            for (let key in formatData.jobHistories) {
              // 見出し
              let item = formatData.jobHistories[key]
              if (item && item.businessArea && item.businessArea.indexOf(keyword) >= 0) {
                _check = true
              }
              for (let subkey in item.projects) {
                let subitem = item.projects[subkey]
                if (subitem && subitem.contentsOfProject && subitem.contentsOfProject.indexOf(keyword) >= 0) {
                  _check = true
                }
                if (subitem && subitem.projectTitle && subitem.projectTitle.indexOf(keyword) >= 0) {
                  _check = true
                }
                if (subitem && subitem.position && subitem.position.indexOf(keyword) >= 0) {
                  _check = true
                }
              }
            }

          }
          return _check
        },
        keywordCheckRirekisho: function (targetData, keywordlist) {
          for (const keyword in keywordlist) {
            for (let key in targetData.educationalHistories) {
              // 見出し
              let item = targetData.educationalHistories[key]
              if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
                return true
              }
            }
            for (let key in targetData.jobHistories) {
              // 見出し
              let item = targetData.jobHistories[key]
              if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
                return true
              }
            }
            for (let key in targetData.licenseHistories) {
              // 見出し
              let item = targetData.licenseHistories[key]
              if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
                return true
              }
            }
          }
          return false
        },
        keywordCheckShokumukeirekishoOnlyLicense: function (targetData, keyword) {

          if (targetData.skillsToUse) {
            for (let key in targetData.skillsToUse) {
              let item = targetData.skillsToUse[key]
              if (item && item.skillname && item.skillname.indexOf(keyword) >= 0) {
                return true
              }
            }
          }
          return false
        },
        keywordCheckShokumukeirekisho: function (targetData, keywordlist) {
          for (const keyword in keywordlist) {
            if (targetData.prMessage && targetData.prMessage.indexOf(keywordlist[keyword]) >= 0) {
              return true
            }
            if (targetData.jobSummary && targetData.jobSummary.indexOf(keywordlist[keyword]) >= 0) {
              return true
            }
            if (targetData.skillsToUse) {
              for (let key in targetData.skillsToUse) {
                let item = targetData.skillsToUse[key]
                if (item && item.skillname && item.skillname.indexOf(keywordlist[keyword]) >= 0) {
                  return true
                }
              }
            }
            if (targetData.jobHistories) {
              for (let key in targetData.jobHistories) {
                // 見出し
                let item = targetData.jobHistories[key]
                if (item && item.businessArea && item.businessArea.indexOf(keywordlist[keyword]) >= 0) {
                  return true
                }
                for (let subkey in item.projects) {
                  let subitem = item.projects[subkey]
                  if (subitem && subitem.contentsOfProject && subitem.contentsOfProject.indexOf(keywordlist[keyword]) >= 0) {
                    return true
                  }
                  if (subitem && subitem.projectTitle && subitem.projectTitle.indexOf(keywordlist[keyword]) >= 0) {
                    return true
                  }
                  if (subitem && subitem.position && subitem.position.indexOf(keywordlist[keyword]) >= 0) {
                    return true
                  }
                }
              }

            }
          }
          return false
        },
        checkJoblistKeyword: function (formatId, formatData) {
          let _keyword = ''
          for (let key in this.joblistKeyword) {
            if (this.keywordCheck(formatId, formatData, this.joblistKeyword[key])) {
              _keyword = this.joblistKeyword[key]
              return _keyword
            }
          }
          return _keyword
        },
        getPrefJoblist: function (basicData) {
          let _pref = ''
          for (let key in this.joblistPrefs) {
            if (basicData.address1.indexOf(this.joblistPrefs[key]) >= 0) {
              _pref = this.joblistPrefs[key]
            }
          }
          return _pref
        },
        addressCheck: function (basicData, addresslist) {
          for (const key in addresslist) {
            if (basicData.address1 && basicData.address1.indexOf(addresslist[key]) >= 0) {
              return true
            }
          }
          return false
        },
        displayFrontEndPopupRenew: function (formatId, formatData, basicData, otherFormatData, request_data, previewFormat) {

          if (formatId == "rirekisho_esf_challenged") {
            return false
          }
          let isYagish_1 = false
          let isMedley1 = false
          let isMedley2 = false
          let isMedley3 = false
          let isMedley4 = false
          let isMedley5 = false
          let isMedley6 = false
          let isMedley7 = false
          let isMedley8 = false
          let isMedley9 = false
          let isMedley10 = false
          let isTryt = false
          let isKirara = false
          let isSimple1 = false
          let isSimple2 = false
          let isSimple3 = false
          let isBaton = false
          let isBaton2 = false
          let isSystemShared = false
          let isSystemShared2 = false
          let isSystemShared3 = false
          let isSystemShared4 = false
          let isSystemShared5 = false
          let isSystemShared6 = false
          let isSystemShared8 = false
          let isSystemShared9 = false
          let isSystemShared10 = false
          let isJaic1 = false
          let isJaic2 = false
          let isJaic3 = false
          let isMynaviMs = false
          let isJigen = false
          let medleyID = 1
          let isMedley_Link_5 = false
          let isMedley_Link_6 = false
          let isMedley_Link_7 = false
          let isMedley_Link_8 = false
          let isMedley_Link_9 = false
          let isMedley_Link_10 = false
          let isMedley_Link_11 = false
          let isMedley_Link_12 = false
          let isMedley_Link_13 = false
          let isMedley_Link_14 = false
          let isMedley_Link_15 = false
          let isMedley_Link_16 = false
          let isMedley_Link_17 = false
          let isMedley_Link_18 = false
          let isMedley_Link_19 = false
          let isMedley_Link_20 = false
          let isMedley_Link_21 = false
          let isMedley_Link_22 = false


          let isJob919_1 = false
          let isJob919_2 = false
          let isJob919_3 = false
          let isJob919_4 = false
          let isJob919_5 = false
          let isJob919_6 = false
          let isJob919_7 = false
          let isJob919_8 = false
          let isJob919_9 = false


          let isPersolinnovation_1 = false
          let isPersolinnovation_2 = false


          let isHrcareer_1 = false
          let isHrcareer_2 = false
          let isHrcareer_3 = false
          let isHrcareer_4 = false
          let isHrcareer_5 = false
          let isHrcareer_6 = false
          let isHrcareer_7 = false
          let isHrcareer_8 = false
          let isHrcareer_9 = false
          let isHrcareer_10 = false
          let isHrcareer_11 = false
          let isHrcareer_12 = false
          let isHrcareer_13 = false
          let isHrcareer_14 = false
          let isHrcareer_15 = false
          let isMiraiyu_1 = false
          let isMiraiyu_2 = false
          let isMiraiyu_3 = false
          let isMiraiyu_4 = false
          let isNeocareer_1 = false
          let isNeocareer_2 = false
          let isNeocareer_3 = false
          let isNeocareer_4 = false

          let isCareerdraft_1 = false
          let isYagish = false
          let isReastage_1 = false
          let isMynavi_1 = false
          let isRecruitMc1 = false
          let isRecruitMc2 = false
          let isAsiro_1 = false
          let isAsiro_2 = false
          let isAsiro_3 = false
          let isAsiro_4 = false
          let isAsiro_5 = false
          let isAsiro_6 = false
          let isCapla_1 = false
          let isCapla_2 = false
          let isBridge_1 = false
          let isDely_1 = false
          let isRozas_1 = false
          let isWorkport_1 = false
          let isWorkport_2 = false
          let isWorkport_3 = false
          let isWorkport_4 = false

          let isAgrinavi_1 = false

          let isRecree_1 = false
          let isRecree_2 = false
          let isRecree_3 = false
          let isRecree_4 = false
          let isRecree_5 = false
          let isArowtrail_1 = false
          let isArowtrail_2 = false
          let isArowtrail_3 = false
          let isTunaguba_1 = false

          let isKrasys_2 = false
          let isPharmacareer_1 = false
          let isXmile_1 = false
          let isXmile_2 = false
          let isXmile_3 = false
          let isXmile_4 = false

          let isPleiades_1 = false
          let isPleiades_2 = false
          let isPleiades_3 = false
          let isPleiades_4 = false
          let isPleiades_5 = false
          let isPleiades_6 = false
          let isPleiades_7 = false
          let isPleiades_8 = false
          let isPleiades_9 = false
          let isPleiades_10 = false
          let isPleiades_11 = false
          let isPleiades_12 = false
          let isPleiades_13 = false
          let isPleiades_14 = false
          let isPleiades_15 = false
          let isPleiades_16 = false
          let isPleiades_17 = false
          let isPleiades_18 = false


          let isPeacekaigo_2 = false

          let isPeacekaigo_4 = false
          let isPeacekaigo_5 = false
          let isHitotech_1 = false
          let isHitotech_2 = false
          let isHitotech_3 = false
          let isHitotech_4 = false


          let isHitotechNeocareer_1 = false

          let isTechouse_1 = false
          let isTechouse_2 = false
          let isTechouse_3 = false

          let isUsenworking_1 = false
          let isUsenworking_2 = false
          let isUsenworking_3 = false
          let isUsenworking_4 = false

          let isSms_1 = false
          let isSms_2 = false
          let isSms_3 = false

          let is400F_1 = false
          let isKikkakeagent_1 = false
          let isPrimalwork_1 = false

          let isHuproinc_1 = false
          let isStarlabo_1 = false
          let isStarlabo_2 = false
          console.error(otherFormatData)

          if (true) {
            if (this.keywordCheck(formatId, formatData, '介護士') || this.keywordCheck(formatId, formatData, 'ヘルパー') || this.keywordCheck(formatId, formatData, '介護福祉士')) {
              isMedley1 = true
              medleyID = 1
            } else if (this.keywordCheck(formatId, formatData, '保育')) {
              isMedley2 = true
              medleyID = 2
            } else if (this.keywordCheck(formatId, formatData, '薬剤')) {
              isMedley3 = true
              medleyID = 3
            } else if (this.keywordCheck(formatId, formatData, '作業療法') || this.keywordCheck(formatId, formatData, '理学療法')
              || this.keywordCheck(formatId, formatData, '言語聴覚') || this.keywordCheck(formatId, formatData, '視能訓練')) {
              isMedley4 = true
              medleyID = 4
            } else if (this.keywordCheck(formatId, formatData, '歯科衛生')) {
              isMedley5 = true
              medleyID = 5
            } else if (this.keywordCheck(formatId, formatData, '歯科助手')) {
              isMedley6 = true
              medleyID = 6
            } else if (this.keywordCheck(formatId, formatData, '看護師') || this.keywordCheck(formatId, formatData, '准看護師')) {
              isMedley7 = true
              medleyID = 7
            }

          }


          let yagish1KeywordArray = ['G2BAi4bWlzPRQ2vEF9ajZZx4ylX2']
          if (this.keywordCheckRirekisho(formatData, yagish1KeywordArray)
            || this.keywordCheckShokumukeirekisho(formatData, yagish1KeywordArray)) {
            isYagish_1 = true
          }

          let sms1AddressArray = ['練馬区光が丘']
          let sms1KeywordArray = ['介護士', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員', 'ケアマネジャー']
          if (true) {
            if (basicData.age >= 20 && basicData.age <= 59) {
              if (this.keywordCheckRirekisho(formatData, sms1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, sms1KeywordArray)) {
                isSms_1 = true
              }
            }
          }
          let sms2KeywordArray = ['栄養士']
          if (true) {
            if (basicData.age >= 23 && basicData.age <= 55) {
              if (this.keywordCheckRirekisho(formatData, sms2KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, sms2KeywordArray)) {
                isSms_2 = true
              }
            }
          }
          let sms3KeywordArray = ['保育士']
          if (true) {
            if (basicData.age >= 20 && basicData.age <= 69) {
              if (this.keywordCheckRirekisho(formatData, sms3KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, sms3KeywordArray)) {
                isSms_3 = true
              }
            }
          }



          let mynavi1addressArray = ['東京都']
          if (this.addressCheck(basicData, mynavi1addressArray)) {
            if (basicData.age <= 30 && basicData.age >= 18) {
              isMynavi_1 = true
            }
          }

          let trytaddressArray = ['岩手県', '茨城県', '京都府', '兵庫県', '滋賀県', '奈良県', '広島県', '山口県', '鹿児島県', '北海道', '愛知県', '岐阜県', '香川県', '富山県', '青森県', '鳥取県', '静岡県', '三重県', '千葉県', '新潟県', '石川県', '山梨県', '和歌山県', '福井県', '大阪府']
          if (this.addressCheck(basicData, trytaddressArray)) {
            if (this.keywordCheck2(formatId, formatData, '正看護師') || this.keywordCheck2(formatId, formatData, '准看護師') || this.keywordCheck2(formatId, formatData, '保健師') || this.keywordCheck2(formatId, formatData, '助産師')) {
              isTryt = true
            }
          }

          let kiraraaddressArray = ['東京都']
          if (this.addressCheck(basicData, kiraraaddressArray)) {
            if (this.keywordCheck2(formatId, formatData, '保育士')) {
              if (basicData.age < 50 && basicData.age >= 22) {
                isKirara = true
              }
            }
          }
          // isKirara = false
          let simple1addressArray = ['東京都']
          if (this.addressCheck(basicData, simple1addressArray)) {
            if (this.keywordCheck(formatId, formatData, '保育士')) {
              if (basicData.age < 60 && basicData.age >= 22) {
                isSimple1 = false
              }
            }
          }
          let simple2addressArray = ['神奈川県', '千葉県', '埼玉県']
          if (this.addressCheck(basicData, simple2addressArray)) {
            if (this.keywordCheck(formatId, formatData, '保育士')) {
              if (basicData.age < 60 && basicData.age >= 22) {
                isSimple2 = false
              }
            }
          }
          let simple3addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
          if (this.addressCheck(basicData, simple3addressArray)) {
            if (this.keywordCheck(formatId, formatData, '栄養士')) {
              if (basicData.age < 60 && basicData.age >= 22) {
                isSimple3 = false
              }
            }
          }

          let batonAddressArray = ['東京都']
          if (this.addressCheck(basicData, batonAddressArray)) {
            if (this.keywordCheck(formatId, formatData, '看護')) {
              isBaton = true
            }
          }
          let baton2addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
          if (this.addressCheck(basicData, baton2addressArray)) {
            if (this.keywordCheck(formatId, formatData, '営業')) {
              if (basicData.age < 36 && basicData.age >= 30) {
                isBaton2 = true
              }
            }
          }
          isBaton = false
          isBaton2 = false
          let jaic1addressArray = ['宮城県', '広島県', '福岡県']
          if (this.addressCheck(basicData, jaic1addressArray)) {
            if (basicData.age < 30 && basicData.age >= 20 && formatId == "rerekisho_part_time") {
              isJaic1 = true
            }
          }
          let jaic2addressArray = ['宮城県', '広島県', '福岡県']
          if (this.addressCheck(basicData, jaic2addressArray)) {
            if (basicData.age <= 25 && this.keywordCheck(formatId, formatData, '中退') && (formatId == "rirekisho_job_change" || formatId == "rirekisho_ai_career" ||
              formatId == "rirekisho_job_change2" ||
              formatId == "rirekisho_job_change_old" ||
              formatId == "rirekisho_single" ||
              formatId == "rirekisho_nophoto_double" ||
              formatId == "rirekisho_nophoto")) {
              isJaic2 = true
            }
          }
          let jaic3addressArray = ['宮城県']
          if (this.addressCheck(basicData, jaic3addressArray)) {
            if (basicData.age < 30 && basicData.age >= 20 && (formatId == "rirekisho_job_change" || formatId == "rirekisho_ai_career" ||
              formatId == "rirekisho_job_change2" ||
              formatId == "rirekisho_job_change_old" ||
              formatId == "rirekisho_single" ||
              formatId == "rirekisho_nophoto_double" ||
              formatId == "rirekisho_nophoto")) {
              isJaic3 = true
            }
          }
          isJaic1 = false
          isJaic2 = false
          isJaic3 = false
          if (this.keywordCheck(formatId, formatData, '人事') || this.keywordCheck(formatId, formatData, '法務') || this.keywordCheck(formatId, formatData, '総務') || this.keywordCheck(formatId, formatData, '経理')
            || this.keywordCheck(formatId, formatData, '財務') || this.keywordCheck(formatId, formatData, '労務') || this.keywordCheck(formatId, formatData, '情報システム')) {
            if (basicData.age >= 35) {
              isMynaviMs = true
            }
          }
          isMynaviMs = false

          if (basicData.age >= 35) {
            isJigen = true
          }
          isJigen = false

          isSystemShared = false


          let reastageAddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '愛知県名古屋市', '大阪府', '福岡県']
          let reastageKeywordArray = ['営業', '事務', '販売', '接客']
          let reastageNotKeywordArray = ['学生', '卒業見込み', '日本語検定', 'N1', 'N2', '永住権', '定住者', '配偶者']
          if (this.addressCheck(basicData, reastageAddressArray)) {
            if (basicData.age < 26 && basicData.age >= 18) {
              if (this.keywordCheckRirekisho(formatData, reastageKeywordArray)) {
                if (this.keywordCheckRirekisho(formatData, reastageNotKeywordArray)) {
                  isReastage_1 = false
                } else {
                  isReastage_1 = true
                }
              }
            }
          }



          let systemShared2addressArray = ['北海道', '青森県', '秋田県', '宮城県', '山形県', '福島県', '岩手県', '茨城県', '栃木県', '群馬県', '新潟県', '富山県', '石川県', '長野県', '山梨県', '岐阜県', '福井県', '静岡県', '広島県', '岡山県', '鳥取県', '島根県', '山口県', '愛媛県', '徳島県', '香川県', '高知県', '福岡県', '佐賀県', '大分県', '長崎県', '熊本県', '宮崎県', '鹿児島県', '沖縄県']
          if (this.addressCheck(basicData, systemShared2addressArray)) {
            if (basicData.age < 30 && basicData.age >= 20) {
              isSystemShared2 = true
            }
          }
          isSystemShared2 = false
          let systemShared3addressArray = ['東京都', '神奈川県', '千葉県', '茨城県', '群馬県', '埼玉県', '栃木県']
          if (this.addressCheck(basicData, systemShared3addressArray)) {
            if (formatData.gradeYear == 23) {
              isSystemShared3 = true
            } else {
              if (basicData.age >= 22) {
                isSystemShared3 = true
              }
            }
          }
          isSystemShared3 = false
          let systemShared4addressArray = ['東京都', '神奈川県', '千葉県', '茨城県', '群馬県', '埼玉県', '栃木県', '静岡県', '山梨県']
          let systemShared4KeywordArray = ['エンジニア', 'プログラミング', 'JAVA', 'C#', 'AWS', 'クラウド', 'salesforce', 'セールスフォース', 'コンサル', 'PG', 'SE', 'PM', 'PL', '講師', '教員免許', '教論免許', 'ソフトウェア開発', '基本情報', '応用情報', 'ORACLE', 'Python', 'C言語', 'C++', 'SQL', '日商簿記2級']
          // if (this.keywordCheck(formatId, formatData, 'エンジニア') || this.keywordCheck(formatId, formatData, 'プログラミング') || this.keywordCheck(formatId, formatData, 'JAVA') || this.keywordCheck(formatId, formatData, 'C#') || this.keywordCheck(formatId, formatData, 'AWS') || 
          // this.keywordCheck(formatId, formatData, 'クラウド') || this.keywordCheck(formatId, formatData, 'salesforce') || this.keywordCheck(formatId, formatData, 'セールスフォース') || 
          // this.keywordCheck(formatId, formatData, 'コンサル') || this.keywordCheck(formatId, formatData, 'PG') || this.keywordCheck(formatId, formatData, 'SE') || this.keywordCheck(formatId, formatData, 'PM') || this.keywordCheck(formatId, formatData, 'PL') || 
          // this.keywordCheck(formatId, formatData, '講師') || this.keywordCheck(formatId, formatData, '教員免許') || this.keywordCheck(formatId, formatData, '教論免許') || this.keywordCheck(formatId, formatData, 'ソフトウェア開発') || 
          // this.keywordCheck(formatId, formatData, '基本情報') || this.keywordCheck(formatId, formatData, '応用情報') || this.keywordCheck(formatId, formatData, 'ORACLE') || this.keywordCheck(formatId, formatData, 'Python') || this.keywordCheck(formatId, formatData, 'C言語') || 
          // this.keywordCheck(formatId, formatData, 'C++') || this.keywordCheck(formatId, formatData, 'SQL') || this.keywordCheck(formatId, formatData, '日商簿記2級')) {
          //   if (this.addressCheck(basicData, systemShared4addressArray)) {
          //     if (basicData.age >= 18 && basicData.age <= 35) {
          //       isSystemShared4 = true
          //     }
          //   }
          // }

          if (this.addressCheck(basicData, systemShared4addressArray)) {
            if (basicData.age >= 18 && basicData.age <= 35) {
              if (formatId.indexOf('shokumukeirekisho') >= 0) {
                // 職務経歴書
                if (this.keywordCheckShokumukeirekisho(formatData, systemShared4KeywordArray)) {
                  isSystemShared4 = true
                }
                if (!isSystemShared4) {
                  if (this.keywordCheckRirekisho(otherFormatData, systemShared4KeywordArray)) {
                    isSystemShared4 = true
                  }
                }
              } else {
                // 履歴書
                if (this.keywordCheckRirekisho(formatData, systemShared4KeywordArray)) {
                  isSystemShared4 = true
                }
                if (!isSystemShared4) {
                  if (this.keywordCheckShokumukeirekisho(otherFormatData, systemShared4KeywordArray)) {
                    isSystemShared4 = true
                  }
                }

              }
            }
          }



          // isSystemShared4 = false 
          let systemShared5addressArray = ['東京都', '神奈川県', '千葉県', '茨城県', '群馬県', '栃木県', '静岡県', '山梨県']
          let systemShared5KeywordArray = ['JavaSpring', 'Vue.js', 'React', 'Ruby on Rails', 'Laravel', 'Django', 'JavaScript', 'PHP', 'C+', 'Ruby', '提案', '要件定義', '設計', '開発', '構築', '運用保守', 'Azure', 'GCP', 'Oracle', 'データ分析', 'ITパスポート', 'IPA', 'CCNA', 'CCNP', 'CompTIA', 'PMP', '簿記', '会計士']

          if (this.addressCheck(basicData, systemShared5addressArray)) {
            if (basicData.age >= 18 && basicData.age <= 35) {
              if (formatId.indexOf('shokumukeirekisho') >= 0) {
                // 職務経歴書
                if (this.keywordCheckShokumukeirekisho(formatData, systemShared5KeywordArray)) {
                  isSystemShared5 = true
                }
                if (!isSystemShared5) {
                  if (this.keywordCheckRirekisho(otherFormatData, systemShared5KeywordArray)) {
                    isSystemShared5 = true
                  }
                }
              } else {
                // 履歴書
                if (this.keywordCheckRirekisho(formatData, systemShared5KeywordArray)) {
                  isSystemShared5 = true
                }
                if (!isSystemShared5) {
                  if (this.keywordCheckShokumukeirekisho(otherFormatData, systemShared5KeywordArray)) {
                    isSystemShared5 = true
                  }
                }
              }
            }
          }
          isSystemShared5 = false
          let systemShared8addressArray = ['茨城県', '群馬県', '栃木県', '静岡県', '山梨県']
          let systemShared8KeywordArray = ['日本大学理工学部', '日本工学院 ITカレッジ', '船橋情報ビジネス専門学校', '日本電子専門学校', '東京電子専門学校', 'HAL東京', 'ITエンジニア科', '情報処理専門学校']
          if (this.addressCheck(basicData, systemShared8addressArray)) {
            if (basicData.age >= 18 && basicData.age <= 35) {
              if (formatId.indexOf('shokumukeirekisho') >= 0) {
                // 職務経歴書
                if (this.keywordCheckShokumukeirekisho(formatData, systemShared8KeywordArray)) {
                  isSystemShared8 = true
                }
                if (!isSystemShared8) {
                  if (this.keywordCheckRirekisho(otherFormatData, systemShared8KeywordArray)) {
                    isSystemShared8 = true
                  }
                }
              } else {
                // 履歴書
                if (this.keywordCheckRirekisho(formatData, systemShared8KeywordArray)) {
                  isSystemShared8 = true
                }
                if (!isSystemShared8) {
                  if (this.keywordCheckShokumukeirekisho(otherFormatData, systemShared8KeywordArray)) {
                    isSystemShared8 = true
                  }
                }
              }
            }
          }

          let systemShared6addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
          let systemShared6KeywordArray = ['IT講師', 'IT研修講師', 'プログラミング講師', '学芸大学', 'インターネットアカデミー', 'トレノケート', 'KENスクール', 'リナックスアカデミー', 'インソース', 'ラーニングエージェンシー', '富士通ラーニングメディア', '株式会社フルネス', '株式会社エンベックスエデュケーション', '株式会社リカレント', '神田ITスクール', '株式会社FusionOne', 'ITカレッジ', 'リゾーム', '株式会社シンクスバンク', '株式会社クロノス', 'SEカレッジ', '株式会社 SEプラス', 'TECHSEED', '株式会社アルバイトタイムス']
          if (this.addressCheck(basicData, systemShared6addressArray)) {
            if (basicData.age >= 18 && basicData.age <= 35) {
              if (formatId.indexOf('shokumukeirekisho') >= 0) {
                // 職務経歴書
                if (this.keywordCheckShokumukeirekisho(formatData, systemShared6KeywordArray)) {
                  isSystemShared6 = true
                }
                if (!isSystemShared6) {
                  if (this.keywordCheckRirekisho(otherFormatData, systemShared6KeywordArray)) {
                    isSystemShared6 = true
                  }
                }
              } else {
                // 履歴書
                if (this.keywordCheckRirekisho(formatData, systemShared6KeywordArray)) {
                  isSystemShared6 = true
                }
                if (!isSystemShared6) {
                  if (this.keywordCheckShokumukeirekisho(otherFormatData, systemShared6KeywordArray)) {
                    isSystemShared6 = true
                  }
                }
              }
            }
          }


          let systemShared9addressArray = ['茨城県', '群馬県', '栃木県', '静岡県', '山梨県']
          let systemShared9KeywordArray = ['SES営業', 'マーケティング', 'デジタルマーケ', 'WEBデザイン', '新聞配達', '牛乳配達', 'ブライダルコーディネーター']
          if (this.addressCheck(basicData, systemShared9addressArray)) {
            if (basicData.age >= 18 && basicData.age <= 35) {
              if (formatId.indexOf('shokumukeirekisho') >= 0) {
                // 職務経歴書
                if (this.keywordCheckShokumukeirekisho(formatData, systemShared9KeywordArray)) {
                  isSystemShared9 = true
                }
                if (!isSystemShared9) {
                  if (this.keywordCheckRirekisho(otherFormatData, systemShared9KeywordArray)) {
                    isSystemShared9 = true
                  }
                }
              } else {
                // 履歴書
                if (this.keywordCheckRirekisho(formatData, systemShared9KeywordArray)) {
                  isSystemShared9 = true
                }
                if (!isSystemShared9) {
                  if (this.keywordCheckShokumukeirekisho(otherFormatData, systemShared9KeywordArray)) {
                    isSystemShared9 = true
                  }
                }
              }
            }
          }




          let systemShared10addressArray = ['茨城県', '群馬県', '栃木県', '静岡県', '山梨県']
          let systemShared10KeywordArray = ['IT講師', 'IT研修講師', 'プログラミング講師', '学芸大学', 'インターネットアカデミー', 'トレノケート', 'KENスクール', 'リナックスアカデミー', 'インソース', 'ラーニングエージェンシー', '富士通ラーニングメディア', '株式会社フルネス', '株式会社エンベックスエデュケーション', '株式会社リカレント', '神田ITスクール', '株式会社FusionOne', 'ITカレッジ', 'リゾーム', '株式会社シンクスバンク', '株式会社クロノス', 'SEカレッジ', '株式会社 SEプラス', 'TECHSEED', '株式会社アルバイトタイムス']
          if (this.addressCheck(basicData, systemShared10addressArray)) {
            if (basicData.age >= 18 && basicData.age <= 35) {
              if (formatId.indexOf('shokumukeirekisho') >= 0) {
                // 職務経歴書
                if (this.keywordCheckShokumukeirekisho(formatData, systemShared10KeywordArray)) {
                  isSystemShared10 = true
                }
                if (!isSystemShared10) {
                  if (this.keywordCheckRirekisho(otherFormatData, systemShared10KeywordArray)) {
                    isSystemShared10 = true
                  }
                }
              } else {
                // 履歴書
                if (this.keywordCheckRirekisho(formatData, systemShared10KeywordArray)) {
                  isSystemShared10 = true
                }
                if (!isSystemShared10) {
                  if (this.keywordCheckShokumukeirekisho(otherFormatData, systemShared10KeywordArray)) {
                    isSystemShared10 = true
                  }
                }
              }
            }
          }



          if (this.keywordCheck(formatId, formatData, '施工管理')) {
            if (basicData.age <= 65 && basicData.age >= 20) {
              isJob919_1 = true
            }
          }

          if (this.keywordCheck(formatId, formatData, '監理技術者')) {
            if (basicData.age <= 65 && basicData.age >= 20) {
              isJob919_7 = true
            }
          }
          let job919addressArray = ["和歌山県", "北海道", "兵庫県", "福島県", "福岡県", "福井県", "富山県", "奈良県", "栃木県", "東京都", "長野県", "大分県", "大阪府", "千葉県", "石川県", "静岡県", "青森県", "神奈川県", "新潟県", "秋田県", "鹿児島県", "滋賀県", "山梨県", "山形県", "三重県", "埼玉県", "香川県", "広島県", "群馬県", "熊本県", "京都府", "宮城県", "岐阜県", "岩手県", "沖縄県", "岡山県", "茨城県", "愛媛県", "愛知県"]
          if (this.keywordCheck(formatId, formatData, '自動車整備士')) {
            if (this.addressCheck(basicData, job919addressArray)) {
              if (basicData.age <= 54 && basicData.age >= 20) {
                isJob919_2 = true
              }
            }
          }
          if (this.keywordCheck(formatId, formatData, '自動車検査員')) {
            if (this.addressCheck(basicData, job919addressArray)) {
              if (basicData.age <= 54 && basicData.age >= 20) {
                isJob919_8 = true
              }
            }
          }
          if (this.keywordCheck(formatId, formatData, '板金塗装')
            || this.keywordCheck(formatId, formatData, 'ジーゼル整備士')
            || this.keywordCheck(formatId, formatData, 'ガソリン整備士')
            || this.keywordCheck(formatId, formatData, '自動車整備工')) {
            if (this.addressCheck(basicData, job919addressArray)) {
              if (basicData.age <= 54 && basicData.age >= 20) {
                isJob919_9 = true
              }
            }
          }
          if (this.keywordCheck(formatId, formatData, '建築士')) {
            if (basicData.age <= 65 && basicData.age >= 20) {
              isJob919_3 = true
            }
          }
          if (this.keywordCheck(formatId, formatData, '電気主任技術者')) {
            if (basicData.age <= 65 && basicData.age >= 20) {
              isJob919_4 = true
            }
          }
          let job919_5_addressArray = ['香川県', '北海道', '青森県', '宮城県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '岐阜県', '静岡県', '愛知県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '岡山県', '広島県', '山口県', '愛媛県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県']
          let job919_5KeywordArray = ['看護師']
          if (this.keywordCheck(formatId, formatData, '看護師')
            || this.keywordCheckShokumukeirekisho(formatData, job919_5KeywordArray)) {
            if (this.addressCheck(basicData, job919_5_addressArray)) {
              if (basicData.age <= 39 && basicData.age >= 23) {
                isJob919_5 = true
              }
            }
          }
          let job919_6_keywordArray = ['CRA', '臨床開発', 'CRC', '治験', '国際共同治験', '品質管理', '品質保証', '監査対応', '統計解析', 'データマネジメント', 'PMS', 'PV', '薬事', '生産技術', '保全', '設備導入', '臨床検査技師', 'GCP', '医薬', '医療用', '新薬', 'ジェネリック', 'CRO', 'CMO', 'MR', 'バイオ', '細胞治療', '再生医療', '抗体', '遺伝子']
          if (basicData.age >= 20 && basicData.age <= 40) {
            if (formatId.indexOf('shokumukeirekisho') >= 0) {
              // 職務経歴書
              if (this.keywordCheckShokumukeirekisho(formatData, job919_6_keywordArray)) {
                isJob919_6 = true
              }
              if (!isJob919_6) {
                if (this.keywordCheckRirekisho(otherFormatData, job919_6_keywordArray)) {
                  isJob919_6 = true
                }
              }
            } else {
              // 履歴書
              if (this.keywordCheckRirekisho(formatData, job919_6_keywordArray)) {
                isJob919_6 = true
              }
              if (!isJob919_6) {
                if (this.keywordCheckShokumukeirekisho(otherFormatData, job919_6_keywordArray)) {
                  isJob919_6 = true
                }
              }
            }
          }

          if (this.keywordCheck(formatId, formatData, 'ドライバー')) {
            if (basicData.age <= 59 && basicData.age >= 31) {
              isMiraiyu_1 = false
            }
          }
          let miraiyu2addressArray = ['東京都', '神奈川県']
          if (this.addressCheck(basicData, miraiyu2addressArray)) {
            if (basicData.age == 18) {
              isMiraiyu_2 = false
            }
            if (this.keywordCheck(formatId, formatData, '軽貨物') || this.keywordCheck(formatId, formatData, 'トラック') || this.keywordCheck(formatId, formatData, '配送') || this.keywordCheck(formatId, formatData, '長距離') || this.keywordCheck(formatId, formatData, '運送') || this.keywordCheck(formatId, formatData, '物流') || this.keywordCheck(formatId, formatData, '宅配') || this.keywordCheck(formatId, formatData, '運輸') || this.keywordCheck(formatId, formatData, '大型免許') || this.keywordCheck(formatId, formatData, '送迎') || this.keywordCheck(formatId, formatData, '急便') || this.keywordCheck(formatId, formatData, '運行管理') || this.keywordCheck(formatId, formatData, '運転手') || this.keywordCheck(formatId, formatData, 'ロジスティクス')) {
              // if (this.keywordCheck(formatId, formatData, '普通免許') || this.keywordCheck(formatId, formatData, '準中型免許') || this.keywordCheck(formatId, formatData, '中型免許') || this.keywordCheck(formatId, formatData, '大型免許') || this.keywordCheck(formatId, formatData, '大型特殊免許') || this.keywordCheck(formatId, formatData, '牽引（けん引・けんいん）免許') || this.keywordCheck(formatId, formatData, '普通第二種免許') || this.keywordCheck(formatId, formatData, '大型第二種免許') || this.keywordCheck(formatId, formatData, '中型第二種免許') || this.keywordCheck(formatId, formatData, '大型特殊第二種免許') || this.keywordCheck(formatId, formatData, '牽引第二種免許')) {
              if (basicData.age >= 20 && basicData.age <= 59) {
                isMiraiyu_3 = true
              }
              // }
            }
            if (this.keywordCheck(formatId, formatData, 'タクシー') || this.keywordCheck(formatId, formatData, '交通') || this.keywordCheck(formatId, formatData, 'ハイヤー')) {
              // if (this.keywordCheck(formatId, formatData, '普通免許') || this.keywordCheck(formatId, formatData, '準中型免許') || this.keywordCheck(formatId, formatData, '中型免許') || this.keywordCheck(formatId, formatData, '大型免許') || this.keywordCheck(formatId, formatData, '大型特殊免許') || this.keywordCheck(formatId, formatData, '牽引（けん引・けんいん）免許') || this.keywordCheck(formatId, formatData, '普通第二種免許') || this.keywordCheck(formatId, formatData, '大型第二種免許') || this.keywordCheck(formatId, formatData, '中型第二種免許') || this.keywordCheck(formatId, formatData, '大型特殊第二種免許') || this.keywordCheck(formatId, formatData, '牽引第二種免許')) {
              if (basicData.age >= 20 && basicData.age <= 59) {
                isMiraiyu_4 = true
              }
              // }
            }

          }




          let asiro1AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府', '奈良県', '京都府']
          let asiro1KeywordArray = ['弁護士登録', '司法試験合格']
          if (this.addressCheck(basicData, asiro1AddressArray)) {
            if (basicData.age >= 30 && basicData.age <= 45) {
              if (formatId.indexOf('shokumukeirekisho') >= 0) {
                // 職務経歴書
                if (this.keywordCheckShokumukeirekisho(formatData, asiro1KeywordArray)) {
                  isAsiro_1 = true
                }
                if (!isAsiro_1) {
                  if (this.keywordCheckRirekisho(otherFormatData, asiro1KeywordArray)) {
                    isAsiro_1 = true
                  }
                }
              } else {
                // 履歴書
                if (this.keywordCheckRirekisho(formatData, asiro1KeywordArray)) {
                  isAsiro_1 = true
                }
                if (!isAsiro_1) {
                  if (this.keywordCheckShokumukeirekisho(otherFormatData, asiro1KeywordArray)) {
                    isAsiro_1 = true
                  }
                }
              }
            }
          }

          let problemsolving1AddressArray = ['大阪府', '兵庫県', '京都府', '滋賀県', '奈良県', '和歌山県']
          let problemsolving1KeywordArray = ['看護師']

          let problemsolving2AddressArray = ['香川県', '愛媛県', '徳島県']
          let problemsolving2KeywordArray = ['介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']

          let isPersolinnovation_1AddressArray = ['東京', '神奈川', '埼玉', '千葉']
          let isPersolinnovation_1KeywordArray = ['介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          if (this.addressCheck(basicData, isPersolinnovation_1AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isPersolinnovation_1KeywordArray)) {
              if (basicData.age >= 20 && basicData.age <= 34) {
                isPersolinnovation_1 = true

              } else if (basicData.age >= 35 && basicData.age <= 59) {
                isPersolinnovation_2 = true

              }
            }
          }

          if (!(basicData.tel1) ||
            !(basicData.tel2) ||
            !(basicData.tel3)) {
          } else {

            let hrcareer1AddressArray = ['東京都', '千葉県', '神奈川県', '埼玉県', '大阪府', '京都府', '兵庫県']
            let hrcareer1KeywordArray = ['保育士']
            if (this.addressCheck(basicData, hrcareer1AddressArray) || true) {
              if (basicData.age >= 20 && basicData.age <= 50) {
                if (this.keywordCheckRirekisho(formatData, hrcareer1KeywordArray)) {
                  isHrcareer_1 = true
                }
              }
              if (basicData.age <= 34) {
                if (this.keywordCheckRirekisho(formatData, hrcareer1KeywordArray)) {
                  isHrcareer_5 = true
                }
              } else if (basicData.age >= 35) {
                if (this.keywordCheckRirekisho(formatData, hrcareer1KeywordArray)) {
                  isHrcareer_6 = true
                }
              }
            }
            let hrcareer2AddressArray = ['東京都', '千葉県', '神奈川県', '埼玉県', '大阪府', '京都府', '兵庫県', '北海道']
            let hrcareer2KeywordArray = ['看護']

            let hrcareer2NotInKeywordArray = ['動物', '中退']
            if (this.addressCheck(basicData, hrcareer2AddressArray) || true) {
              if (this.keywordCheckRirekisho(formatData, hrcareer2KeywordArray)) {
                isHrcareer_2 = true
              }
              if (basicData.age <= 34) {
                if (this.keywordCheckRirekisho(formatData, hrcareer2NotInKeywordArray)) {
                  isHrcareer_7 = false
                } else if (this.keywordCheckRirekisho(formatData, hrcareer2KeywordArray)) {
                  isHrcareer_7 = true
                }
              } else if (basicData.age >= 35) {
                if (this.keywordCheckRirekisho(formatData, hrcareer2NotInKeywordArray)) {
                  isHrcareer_8 = false
                } else if (this.keywordCheckRirekisho(formatData, hrcareer2KeywordArray)) {
                  isHrcareer_8 = true
                }
              }
            }


            // let hrcareer3AddressArray = ['東京都', '千葉県', '神奈川県', '埼玉県', '大阪府', '京都府', '兵庫県', '静岡県', '北海道']
            let hrcareer3AddressArray = ['東京都', '神奈川県']
            let temphrcareerAddressArray = ['大阪府', '兵庫県', '東京都', '神奈川県', '千葉県', '埼玉県']
            let hrcareer3KeywordArray = ['介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員', 'ヘルパー２級', 'ヘルパー１級', 'ヘルパー二級', 'ヘルパー一級']
            if (true) {
              if (this.keywordCheckRirekisho(formatData, hrcareer3KeywordArray)) {
                isHrcareer_3 = true
              }
              if (basicData.age <= 34) {
                if (this.keywordCheckRirekisho(formatData, hrcareer3KeywordArray)) {
                  isHrcareer_9 = true
                }
              } else if (basicData.age >= 35) {
                if (this.keywordCheckRirekisho(formatData, hrcareer3KeywordArray)) {
                  isHrcareer_10 = true
                }
              }
            }

            // 北海道、東京、神奈川、大阪、兵庫
            hrcareer3AddressArray = ['東京都', '北海道', '神奈川県', '大阪府', '兵庫県']

            if (this.addressCheck(basicData, hrcareer3AddressArray)) {
              if (basicData.age <= 34) {
                if (this.keywordCheckRirekisho(formatData, hrcareer3KeywordArray)) {
                  isHrcareer_13 = true
                }
              } else if (basicData.age >= 35) {
                if (this.keywordCheckRirekisho(formatData, hrcareer3KeywordArray)) {
                  isHrcareer_14 = true
                }
              }
            }
            let hrcareer4AddressArray = ['東京都', '千葉県', '神奈川県', '埼玉県', '大阪府', '兵庫県']
            let hrcareer4KeywordArray = ['栄養士']
            if (true) {
              if (basicData.age >= 20 && basicData.age <= 55) {
                if (this.keywordCheckRirekisho(formatData, hrcareer4KeywordArray)) {
                  isHrcareer_4 = true
                }
              }
              if (basicData.age <= 34) {
                if (this.keywordCheckRirekisho(formatData, hrcareer4KeywordArray)) {
                  isHrcareer_11 = true
                }
              } else if (basicData.age >= 35) {
                if (this.keywordCheckRirekisho(formatData, hrcareer4KeywordArray)) {
                  isHrcareer_12 = true
                }
              }
            }

            let hrcareer15KeywordArray = ['建築士', '宅地建物取引士', '宅建']
            if (true) {
              if (this.keywordCheckRirekisho(formatData, hrcareer15KeywordArray)) {
                isHrcareer_15 = true
              }
            }

          }



          let asiro2AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府', '奈良県', '京都府']
          let asiro2KeywordArray = ['公認会計士', '監査法人']
          if (this.addressCheck(basicData, asiro2AddressArray)) {
            if (basicData.age >= 30 && basicData.age <= 45) {
              if (formatId.indexOf('shokumukeirekisho') >= 0) {
                // 職務経歴書
                if (this.keywordCheckShokumukeirekisho(formatData, asiro2KeywordArray)) {
                  isAsiro_2 = true
                }
                if (!isAsiro_2) {
                  if (this.keywordCheckRirekisho(otherFormatData, asiro2KeywordArray)) {
                    isAsiro_2 = true
                  }
                }
              } else {
                // 履歴書
                if (this.keywordCheckRirekisho(formatData, asiro2KeywordArray)) {
                  isAsiro_2 = true
                }
                if (!isAsiro_2) {
                  if (this.keywordCheckShokumukeirekisho(otherFormatData, asiro2KeywordArray)) {
                    isAsiro_2 = true
                  }
                }
              }
            }
          }

          let asiro3AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府', '奈良県', '京都府']
          let asiro3KeywordArray = ['税理士', '税理士法人', '税理士科目合格']
          if (this.addressCheck(basicData, asiro3AddressArray)) {
            if (basicData.age >= 30 && basicData.age <= 45) {
              if (formatId.indexOf('shokumukeirekisho') >= 0) {
                // 職務経歴書
                if (this.keywordCheckShokumukeirekisho(formatData, asiro3KeywordArray)) {
                  isAsiro_3 = true
                }
                if (!isAsiro_3) {
                  if (this.keywordCheckRirekisho(otherFormatData, asiro3KeywordArray)) {
                    isAsiro_3 = true
                  }
                }
              } else {
                // 履歴書
                if (this.keywordCheckRirekisho(formatData, asiro3KeywordArray)) {
                  isAsiro_3 = true
                }
                if (!isAsiro_3) {
                  if (this.keywordCheckShokumukeirekisho(otherFormatData, asiro3KeywordArray)) {
                    isAsiro_3 = true
                  }
                }
              }
            }
          }

          let asiro4AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府', '奈良県', '京都府']
          let asiro4KeywordArray = ['労務', '制度設計', '採用支援']
          if (this.addressCheck(basicData, asiro4AddressArray)) {
            if (basicData.age >= 30 && basicData.age <= 45) {
              if (formatId.indexOf('shokumukeirekisho') >= 0) {
                // 職務経歴書
                if (this.keywordCheckShokumukeirekisho(formatData, asiro4KeywordArray)) {
                  isAsiro_4 = true
                }
                if (!isAsiro_4) {
                  if (this.keywordCheckRirekisho(otherFormatData, asiro4KeywordArray)) {
                    isAsiro_4 = true
                  }
                }
              } else {
                // 履歴書
                if (this.keywordCheckRirekisho(formatData, asiro4KeywordArray)) {
                  isAsiro_4 = true
                }
                if (!isAsiro_4) {
                  if (this.keywordCheckShokumukeirekisho(otherFormatData, asiro4KeywordArray)) {
                    isAsiro_4 = true
                  }
                }
              }
            }
          }


          let asiro5AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府', '奈良県', '京都府']
          let asiro5KeywordArray = ['財務', '会計基準', 'FRS', '簿記１級', '月次決算', '年次決算']
          if (this.addressCheck(basicData, asiro5AddressArray)) {
            if (basicData.age >= 30 && basicData.age <= 45) {
              if (formatId.indexOf('shokumukeirekisho') >= 0) {
                // 職務経歴書
                if (this.keywordCheckShokumukeirekisho(formatData, asiro5KeywordArray)) {
                  isAsiro_5 = true
                }
                if (!isAsiro_5) {
                  if (this.keywordCheckRirekisho(otherFormatData, asiro5KeywordArray)) {
                    isAsiro_5 = true
                  }
                }
              } else {
                // 履歴書
                if (this.keywordCheckRirekisho(formatData, asiro5KeywordArray)) {
                  isAsiro_5 = true
                }
                if (!isAsiro_5) {
                  if (this.keywordCheckShokumukeirekisho(otherFormatData, asiro5KeywordArray)) {
                    isAsiro_5 = true
                  }
                }
              }
            }
          }


          let asiro6AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府', '奈良県', '京都府']
          let asiro6KeywordArray = ['法務部', '法務担当', 'ビジネス法務検定']
          if (this.addressCheck(basicData, asiro6AddressArray)) {
            if (basicData.age >= 30 && basicData.age <= 45) {
              if (formatId.indexOf('shokumukeirekisho') >= 0) {
                // 職務経歴書
                if (this.keywordCheckShokumukeirekisho(formatData, asiro6KeywordArray)) {
                  isAsiro_6 = true
                }
                if (!isAsiro_6) {
                  if (this.keywordCheckRirekisho(otherFormatData, asiro6KeywordArray)) {
                    isAsiro_6 = true
                  }
                }
              } else {
                // 履歴書
                if (this.keywordCheckRirekisho(formatData, asiro6KeywordArray)) {
                  isAsiro_6 = true
                }
                if (!isAsiro_6) {
                  if (this.keywordCheckShokumukeirekisho(otherFormatData, asiro6KeywordArray)) {
                    isAsiro_6 = true
                  }
                }
              }
            }
          }



          let capla1AddressArray = ['岡山県']
          let capla1KeywordArray = ['看護師']
          if (this.addressCheck(basicData, capla1AddressArray)) {
            if (basicData.age >= 40 && basicData.age <= 49) {
              if (formatId.indexOf('shokumukeirekisho') >= 0) {
                // 職務経歴書
                if (this.keywordCheckShokumukeirekisho(formatData, capla1KeywordArray)) {
                  isCapla_1 = true
                }
                if (!isCapla_1) {
                  if (this.keywordCheckRirekisho(otherFormatData, capla1KeywordArray)) {
                    isCapla_1 = true
                  }
                }
              } else {
                // 履歴書
                if (this.keywordCheckRirekisho(formatData, capla1KeywordArray)) {
                  isCapla_1 = true
                }
                if (!isCapla_1) {
                  if (this.keywordCheckShokumukeirekisho(otherFormatData, capla1KeywordArray)) {
                    isCapla_1 = true
                  }
                }
              }
            }
          }

          let capla2AddressArray = ['岡山県', '広島県']
          let capla2KeywordArray = ['介護福祉士', '初任者研修', '実務者研修', 'ヘルパー']
          if (this.addressCheck(basicData, capla2AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 49) {
              if (formatId.indexOf('shokumukeirekisho') >= 0) {
                // 職務経歴書
                if (this.keywordCheckShokumukeirekisho(formatData, capla2KeywordArray)) {
                  isCapla_2 = true
                }
                if (!isCapla_2) {
                  if (this.keywordCheckRirekisho(otherFormatData, capla2KeywordArray)) {
                    isCapla_2 = true
                  }
                }
              } else {
                // 履歴書
                if (this.keywordCheckRirekisho(formatData, capla2KeywordArray)) {
                  isCapla_2 = true
                }
                if (!isCapla_2) {
                  if (this.keywordCheckShokumukeirekisho(otherFormatData, capla2KeywordArray)) {
                    isCapla_2 = true
                  }
                }
              }
            }
          }


          let isAdtop = false
          if (basicData.age < 35) {
            isAdtop = true
          }
          isAdtop = false

          let isRoxx = false
          let roxxaddressArray = ['愛知県', '福岡県', '静岡県', '岐阜県', '東京都', '埼玉県', '神奈川県', '千葉県', '大阪府', '京都府', '兵庫県', '和歌山県', '奈良県', '滋賀県', '名古屋市', '北九州市', '札幌市', '福岡市', '広島市', '仙台市', '静岡市', '新潟市', '浜松市', '岡山市', '熊本市']
          if (this.addressCheck(basicData, roxxaddressArray)) {
            if (basicData.age >= 19 && basicData.age <= 30) {
              isRoxx = true
            }
          }

          let isRoxx2 = false
          let roxxaddressArray2 = ['愛知県', '福岡県', '静岡県', '岐阜県', '東京都', '埼玉県', '神奈川県', '千葉県', '大阪府', '京都府', '兵庫県', '和歌山県', '奈良県', '滋賀県', '名古屋市', '北九州市', '札幌市', '福岡市', '広島市', '仙台市', '静岡市', '新潟市', '浜松市', '岡山市', '熊本市']
          if (this.addressCheck(basicData, roxxaddressArray2)) {
            if (basicData.age >= 31 && basicData.age <= 34) {
              isRoxx2 = true
            }
          }

          let isRoxx3 = false
          let roxxaddressArray3 = ['愛知県', '福岡県', '静岡県', '岐阜県', '東京都', '埼玉県', '神奈川県', '千葉県', '大阪府', '京都府', '兵庫県', '和歌山県', '奈良県', '滋賀県', '名古屋市', '北九州市', '札幌市', '福岡市', '広島市', '仙台市', '静岡市', '新潟市', '浜松市', '岡山市', '熊本市']


          let isRoxx_4 = false
          let roxxaddressArray4 = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府', '兵庫県', '京都府', '愛知県', '福岡県', '宮城県', '静岡県', '奈良県', '群馬県', '茨城県', '栃木県']


          if (this.addressCheck(basicData, roxxaddressArray3)) {
            if (basicData.age >= 21 && basicData.age <= 29 && formatData.gradeYear == 24) {
              isRoxx3 = true
            }
          }



          if (this.addressCheck(basicData, roxxaddressArray4)) {
            if (basicData.age >= 20 && basicData.age <= 34) {
              if (formatData.gradeYear == '' || !(formatData.gradeYear !== undefined)) {
                isRoxx_4 = true
              }
            }
          }

          if (!(basicData.tel1) ||
            !(basicData.tel2) ||
            !(basicData.tel3)) {
            isRoxx = false
            isRoxx2 = false
            isRoxx3 = false
            isRoxx_4 = false
          }

          if (!(formatData.gradeYear)) {
            if (!formatData.foreignStudent) {
              if (this.keywordCheck(formatId, formatData, '大学')) {
                if (basicData.age >= 20 && basicData.age <= 28) {
                  isCareerdraft_1 = true
                }
              }
            }
          }


          if (formatData.gradeYear == 26) {
            isHitotech_1 = true
          }
          let isHitotech_2addressArray = ['愛知県', '石川県', '新潟県', '福井県', '山口県', '岡山県', '広島県', '香川県', '愛媛県', '高知県', '富山県', '長野県', '鳥取県', '島根県', '徳島県']
          if (formatData.gradeYear == 25) {
            if (this.addressCheck(basicData, isHitotech_2addressArray)) {
              isHitotech_2 = true
            }
          }

          let isHitotech_3addressArray = ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '山梨県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県']
          if (formatData.gradeYear == 25) {
            if (this.addressCheck(basicData, isHitotech_3addressArray)) {
              isHitotech_3 = true
            }
          }
          if (!formatData.gradeYear) {
            isHitotech_4 = true
          }


          let bridge1addressArray = ['東京都', '埼玉県', '神奈川県', '千葉県']
          let bridge1KeywordArray = ['USCPA', 'IPO準備', '株式公開', '上場準備', 'ファイナンス', '決算', '開示', '管理会計', '税務', '資金調達', '原価計算', '人事評価', '人事制度', '社会保険労務士', 'リスクマネジメント', '内部統制', '監査役', '経営企画', '情報セキュリティ', 'コンサルタント', 'ファンド', '投資銀行']
          if (this.addressCheck(basicData, bridge1addressArray)) {
            if (basicData.age >= 25 && basicData.age <= 45) {
              console.error(formatData)
              if (this.keywordCheckRirekisho(formatData, bridge1KeywordArray)) {
                isBridge_1 = true
              }
            }
          }
          console.error(isBridge_1)

          let rozas1addressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '茨城県', '群馬県', '栃木県']
          let rozas1KeywordArray = ['看護']
          if (this.addressCheck(basicData, rozas1addressArray)) {
            if (basicData.age >= 40 && basicData.age <= 60) {
              console.error(formatData)
              if (this.keywordCheckRirekisho(formatData, rozas1KeywordArray)) {
                isRozas_1 = true
              }
            }
          }

          let tunaguba1addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '愛知県', '大阪府', '福岡県']
          let tunaguba1KeywordArray = ['未経験', 'スキルアップ', '大学', '免許']
          if (this.addressCheck(basicData, tunaguba1addressArray)) {
            if (basicData.age >= 18 && basicData.age <= 32) {
              if (this.keywordCheckRirekisho(formatData, tunaguba1KeywordArray)) {
                isTunaguba_1 = true
              }
            }
          }

          let dely1addressArray = ['東京都']
          let dely1KeywordArray = ['免許']
          let dely1NotInKeywordArray = ['週1', '週2', '週3', '週4']
          if (this.addressCheck(basicData, dely1addressArray)) {
            if (basicData.age >= 22 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, dely1NotInKeywordArray)) {
                isDely_1 = false
              } else if (this.keywordCheckRirekisho(formatData, dely1KeywordArray)) {
                isDely_1 = true
              }
            }
          }

          let workport1addressArray = ['佐賀県', '長崎県', '大分県', '熊本県', '宮崎県', '鹿児島県', '沖縄県', '広島県', '岡山県', '島根県', '鳥取県', '山口県', '香川県', '愛媛県', '高知県', '徳島県', '青森県', '秋田県', '岩手県', '山形県', '宮城県', '福県島', '石川県', '富山県', '福井県', '新潟県', '長野県']
          let workport1NotAddressArray = ['仙台市', '新潟市', '広島市', '岡山市', '熊本市']
          let workport1KeywordArray = ['エンジニア']
          if (this.addressCheck(basicData, workport1addressArray)) {
            if (this.addressCheck(basicData, workport1NotAddressArray)) {
              //なし
            } else {
              if (basicData.age >= 20 && basicData.age <= 45) {
                if (this.keywordCheckRirekisho(formatData, workport1KeywordArray)
                  || this.keywordCheckShokumukeirekisho(formatData, workport1KeywordArray)) {
                  isWorkport_1 = true
                }
              }
            }
          }
          let workport4addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府', '兵庫県', '京都府', '奈良県', '滋賀県', '和歌山県', '愛知県', '福岡県', '静岡県', '岐阜県', '北海道', '宮城県', '新潟県', '岡山県', '広島県', '熊本県']
          let workport4KeywordArray = ['エンジニア']
          if (this.addressCheck(basicData, workport4addressArray)) {
            if (basicData.age >= 35 && basicData.age <= 42) {
              if (this.keywordCheckRirekisho(formatData, workport4KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, workport4KeywordArray)) {
                isWorkport_4 = true
              }
            }
          }
          let workport2KeywordArray = ['経理']
          if (this.addressCheck(basicData, workport1addressArray)) {
            if (this.addressCheck(basicData, workport1NotAddressArray)) {
              //なし
            } else {
              if (basicData.age >= 20 && basicData.age <= 45) {
                if (this.keywordCheckRirekisho(formatData, workport2KeywordArray)
                  || this.keywordCheckShokumukeirekisho(formatData, workport2KeywordArray)) {
                  isWorkport_2 = true
                }
              }
            }
          }
          let workport3KeywordArray = ['営業']
          if (this.addressCheck(basicData, workport1addressArray)) {
            if (this.addressCheck(basicData, workport1NotAddressArray)) {
              //なし
            } else {
              if (basicData.age >= 20 && basicData.age <= 45) {
                if (this.keywordCheckRirekisho(formatData, workport3KeywordArray)
                  || this.keywordCheckShokumukeirekisho(formatData, workport3KeywordArray)) {
                  isWorkport_3 = true
                }
              }
            }
          }


          let loginess1addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '静岡県']
          let loginess1KeywordArray = ['トラックドライバー', '長距離トラック', '長距離輸送', '大型免許', '準中型免許', '中型免許', 'フォークリフト']



          let agrinavi1addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府', '京都府', '兵庫県', '和歌山県', '奈良県', '京都県', '滋賀県', '愛知県', '福岡県', '岐阜県', '静岡県']
          let agrinavi1KeywordArray = ['農業']
          if (this.addressCheck(basicData, agrinavi1addressArray)) {
            if (basicData.age >= 20 && basicData.age <= 34) {
              if (this.keywordCheckRirekisho(formatData, agrinavi1KeywordArray)) {
                isAgrinavi_1 = true
              }
            }
          }


          let techouse1addressArray = ['愛知県', '栃木県']
          let techouse1KeywordArray = ['工場', '製造', '期間工', '溶接', 'フォークリフト']
          if (this.addressCheck(basicData, techouse1addressArray)) {
            if (basicData.age >= 20 && basicData.age <= 45) {
              if (this.keywordCheckRirekisho(formatData, techouse1KeywordArray)) {
                isTechouse_1 = true
              }
            }
          } else {
            if (basicData.age >= 20 && basicData.age <= 45) {
              if (this.keywordCheckRirekisho(formatData, techouse1KeywordArray)) {
                isTechouse_2 = true
              }
            }
          }

          let techouse3addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '愛知県', '大阪府']
          let techouse3KeywordArray = ['運輸', '運送', '物流', '配送', 'ドライバー', 'トラックドライバー', '長距離トラック', '長距離輸送', '大型免許', '準中型免許', '中型免許', '軽貨物']
          if (this.addressCheck(basicData, techouse3addressArray)) {
            if (basicData.age >= 20 && basicData.age <= 59) {
              if (this.keywordCheckRirekisho(formatData, techouse3KeywordArray)) {
                isTechouse_3 = true
              }
            }
          }


          let isPrimalwork_1addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
          // let isPrimalwork_1_1KeywordArray = ['保守', 'メンテナンス', '修理', '点検', '警備', '配送', '配達', '夜勤', '配達', '指導', 'レクチャー', 'バイトリーダー', 'ホール', 'シフトリーダー', '調理', 'リーダー', '正社員', '成長', '挑戦', 'セールス', 'テレアポ', '受注', '発注', 'アシスタント']
          // let isPrimalwork_1_2KeywordArray = ['鑑定', '査定', '契約', '運行管理', '夜勤', '品質管理', '製品', '歩留まり', '運行管理', '施術', 'ゲスト', 'カウンセリング', '受付', 'コンシェルジュ', '効率', '安定']
          // let isPrimalwork_1_3KeywordArray = ['設計', 'モノづくり', '伝票', '集計', 'サポート', 'ニーズ', '伴走']
          let isPrimalwork_1Array = ['保守', 'メンテナンス', '修理', '点検', '警備', '配送', '配達', '夜勤']
          if (this.addressCheck(basicData, isPrimalwork_1addressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isPrimalwork_1Array)
                || this.keywordCheckShokumukeirekisho(formatData, isPrimalwork_1Array)) {
                isPrimalwork_1 = true
              }
            }
          }




          let is400f1addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '愛知県', '大阪府', '福岡県']
          let is400f1KeywordArray = ['事務', '営業']
          if (this.addressCheck(basicData, is400f1addressArray)) {
            if (basicData.age >= 23 && basicData.age <= 34) {
              if (this.keywordCheckRirekisho(formatData, is400f1KeywordArray)) {
                is400F_1 = true
              }
            }
          }



          let usenworking1addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府']
          let usenworking1KeywordArray = ['飲食', '調理', '厨房', 'キッチン', 'ホール', '店舗', '料理長', '接客', 'SV', '店舗開発']
          // let usenworking1NotKeywordArray = ['週１', '週２', '週３', '週４', '週1', '週2', '週3', '週4', 'パート希望', 'アルバイト希望', '時短']
          let usenworking1NotKeywordArray = ['週１', '週２', '週３', '週４', '週1', '週2', '週3', '週4', 'パート希望', 'アルバイト希望', '時短', '事務', '業務委託']
          if (this.addressCheck(basicData, usenworking1addressArray)) {
            if (this.keywordCheckRirekisho(formatData, usenworking1NotKeywordArray)) {

            } else {
              if (this.keywordCheckRirekisho(formatData, usenworking1KeywordArray)) {
                if (basicData.age >= 27 && basicData.age <= 34) {
                  isUsenworking_1 = true
                } else if (basicData.age >= 35 && basicData.age <= 36) {
                  isUsenworking_2 = true
                }
              }

            }
          }
          let usenworking2addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府']
          let usenworking2KeywordArray = ['営業', 'セールス', 'カスタマーサクセス']
          if (this.addressCheck(basicData, usenworking2addressArray)) {
            if (this.keywordCheckRirekisho(formatData, usenworking2KeywordArray)) {
              if (basicData.age >= 27 && basicData.age <= 34) {
                isUsenworking_3 = true
              } else if (basicData.age >= 35 && basicData.age <= 36) {
                isUsenworking_4 = true
              }
            }
          }




          let agrinavi2addressArray = ['北海道', '青森県', '秋田県', '宮城県', '福島県', '岩手県', '山形県', '群馬県', '茨城県', '栃木県', '新潟県', '富山県', '石川県', '福井県', '長野県', '山梨県', '鳥取県', '島根県', '山口県', '愛媛県', '香川県', '高知県', '徳島県', '大分県', '宮崎県', '鹿児島県', '長崎県', '沖縄県']
          let agrinavi2KeywordArray = ['日本農業技術検定', '農学部', '農業大学', '酪農', '畜産', 'ポートリー', '牧場', 'ファーム', '農業協同組合']


          let xmile1addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '愛知県', '大阪府', '京都府', '奈良県', '兵庫県', '滋賀県', '和歌山県']
          let xmile1KeywordArray = ['タクシー', '普通自動車第二種', '普通自動車第2種', 'ハイヤー']

          if (basicData.age >= 18 && basicData.age <= 64) {
            if (this.keywordCheckRirekisho(formatData, xmile1KeywordArray)) {
              if (this.addressCheck(basicData, xmile1addressArray)) {
                isXmile_1 = true
              } else {
                isXmile_2 = true
              }
            }
          }


          let xmile3addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '愛知県', '大阪府', '京都府', '奈良県', '兵庫県', '滋賀県', '和歌山県']
          let xmile3KeywordArray = ['大型自動車', '中型自動車', 'ドライバー', '運送']

          if (basicData.age >= 18 && basicData.age <= 59) {
            if (this.keywordCheckRirekisho(formatData, xmile3KeywordArray)) {
              if (this.addressCheck(basicData, xmile3addressArray)) {
                isXmile_3 = true
              } else {
                isXmile_4 = true
              }
            }
          }

          let growtrail1KeywordArray = ['看護師']
          if (basicData.age >= 40 && basicData.age <= 60) {
            if (this.keywordCheckRirekisho(formatData, growtrail1KeywordArray)) {
              isArowtrail_1 = true
            }
          }

          let growtrail2KeywordArray = ['作業療法士', '理学療法士']
          if (this.keywordCheckRirekisho(formatData, growtrail2KeywordArray)) {
            isArowtrail_2 = true
          }

          let growtrail3KeywordArray = ['介護福祉士', '介護支援専門員']
          if (basicData.age >= 40 && basicData.age <= 60) {
            if (this.keywordCheckRirekisho(formatData, growtrail3KeywordArray)) {
              isArowtrail_3 = true
            }
          }


          // let recree1KeywordArray = ['現場監督', 'ゼネコン', '現場管理', '土木', '現場代理', '測量士', 'ウィルオブ・コンストラクション', 'ワールドコーポレーション', 'アーキ・ジャパン', 'アイアール', 'テクノプロ・コンストラクション', 'イーフラッグ', 'SUGUNI', 'コプロ・エンジニアード', '夢真', 'アクトエンジニアリング', 'スタッフ・アクティオ', 'UTコンストラクション', 'サイマリーディング', 'ハウスメーカー', 'RCCM', '意匠設計', '内装設計', '構造設計', '設備設計', '設計士', '工事', '改修工事', '修繕工事', '改築工事', '主任技術者', '管理技術者', '工事監理', '専任技術者', 'コンストラクションマネジメント', '技術士', '概略設計', 'リフォーム工事', 'W造', '木造住宅', '戸建て住宅', 'マンション工事', 'ビル工事', '杭工事', '鋼構造物', '法面工事', '港湾工事', '電験', '電気主任', '大規模修繕', '積算', 'サブコン', '電気工事士', '日建学院', 'RC造', 'SRC造', 'PC造', 'S造', '軽量鉄骨造', '木質フレーム構造', '地盤改良工事', 'プレキャストコンクリート工法', 'システム建築工法', 'トンネル工法', '地中構造物工法', '逆打ち工法', 'スリップフォーム工法', 'クライミングフォーム工法', 'トンネル工事', '河川工事', '上下水道工事', '海岸工事', '地滑り防止工事', '災害復旧工事', '地下構造物の建設']
          // if (basicData.age >= 20 && basicData.age <= 55) {
          //   if (this.keywordCheckRirekisho(formatData, recree1KeywordArray)) {
          //     isRecree_1 = true
          //   }
          // }

          let recree2KeywordArray = ['施工監理', '施工管理']
          if (basicData.age >= 20 && basicData.age <= 65) {
            if (this.keywordCheckRirekisho(formatData, recree2KeywordArray)
              || this.keywordCheckShokumukeirekisho(formatData, recree2KeywordArray)) {
              isRecree_2 = true
            }
          }

          let recree345NotKeywordArray = ['IT', 'SE']
          let recree3AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '静岡県', '愛知県', '岐阜県', '大阪府', '京都府', '兵庫県', '奈良県', '和歌山県', '北海道', '広県島', '岡山県']
          // let recree3KeywordArray = ['現場監督', 'ゼネコン', '現場管理', '土木', '現場代理', 'ウィルオブ・コンストラクション', 'ワールドコーポレーション', 'アーキ・ジャパン', 'テクノプロ・コンストラクション', 'イーフラッグ', 'SUGUNI', 'コプロ・エンジニアード', '夢真', 'アクトエンジニアリング', 'スタッフ・アクティオ', 'UTコンストラクション', 'サイマリーディング', 'ハウスメーカー', 'RCCM', '意匠設計', '内装設計', '構造設計', '設備設計', '設計士', '工事', '改修工事', '修繕工事', '改築工事', '主任技術者', '管理技術者', '電験', '電気主任', '大規模修繕', '積算', 'サブコン', '電気工事士', '日建学院', 'RC造', 'SRC造', 'PC造', 'S造', '軽量鉄骨造', '木質フレーム構造', '地盤改良工事', 'プレキャストコンクリート工法', 'システム建築工法', 'トンネル工法', '地中構造物工法', '逆打ち工法', 'スリップフォーム工法', 'クライミングフォーム工法', 'トンネル工事', '河川工事', '上下水道工事', '海岸工事', '地滑り防止工事', '災害復旧工事', '地下構造物の建設', '工事監理', '専任技術者', 'コンストラクションマネジメント', '技術士', '概略設計', 'リフォーム工事', 'W造', '木造住宅', '戸建て住宅', 'マンション工事', 'ビル工事', '杭工事', '鋼構造物', '法面工事', '港湾工事', 'CADオペレーター', '建築CAD検定', '2次元CAD利用技術者', '3次元CAD利用技術者', 'CADデザインマスター', 'CADトレース技士', '共同エンジニアリング', 'JAGフィールド', 'イーフラッグ']
          let recree3KeywordArray = ['建築設計', '工事監督', '建築設備士', '建築積算士', '発注者支援', '共同エンジニアリング', 'JAGフィールド', '工事監理', '専任技術者', 'コンストラクションマネジメント', '管理技術者', '概略設計', 'リフォーム工事', 'W造', 'マンション工事', 'ビル工事', '杭工事', '鋼構造物', '法面工事', '港湾工事', '現場監督', '現場管理', '現場代理', 'ウィルオブ・コンストラクション', 'ワールドコーポレーション', 'アーキ・ジャパン', 'テクノプロ・コンストラクション', 'イーフラッグ', 'SUGUNI', 'コプロ・エンジニアード', '夢真', 'アクトエンジニアリング', 'スタッフ・アクティオ', 'ＵＴコンストラクション', 'サイマリーディング', '意匠設計', '主任技術者', '監理技術者', 'RCCM', '内装設計', '構造設計', '設備設計', '設計士', '設計監理', '管工事', '改修工事', '修繕工事', '改築工事', '電験', '大規模修繕', '高松建設', 'ヤマギシリフォーム工業', 'カシワバラコーポレーション', 'メルディア', 'フクダアンドパートナーズ', 'ケイアイスター不動産', '一建設', '塩浜工業', 'ホークワン', '北野建設', '生和コーポレーション', '電気工事士', 'RC造', 'PC造', 'S造', '軽量鉄骨造', '木質フレーム構造', '地盤改良工事', 'プレキャストコンクリート工法', 'システム建築工法', 'ツーバイフォー工法', 'トンネル工法', '地中構造物工法', '逆打ち工法', 'スリップフォーム工法', 'クライミングフォーム工法', 'トンネル工事', '河川工事', '上下水道工事', '海岸工事', '地滑り防止工事', '災害復旧工事', '地下構造物の建設', '施工技士', '現場監理', '工事管理', '建築士', '現場所長', '現場主任', '工事主任', '建設コンサルタント', '建築コンサルタント', '住宅リフォーム', '建設マネジメント', 'トライトエンジニアリング', 'ウィルオブコンストラクション', 'コプロエンジニアード', 'テクノプロコンストラクション', 'UTコンストラクション', '設計管理', '土木設計']
          if (basicData.age >= 20 && basicData.age <= 30) {
            if (this.addressCheck(basicData, recree3AddressArray)) {
              if (this.keywordCheckRirekisho(formatData, recree345NotKeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, recree345NotKeywordArray)) {
                isRecree_3 = false
              } else if (this.keywordCheckRirekisho(formatData, recree3KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, recree3KeywordArray)) {
                isRecree_3 = true
              }
            }
          }

          let recree4AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '静岡県', '愛知県', '岐阜県', '大阪府', '京都府', '兵庫県', '奈良県', '和歌山県', '北海道', '広県島', '岡山県']
          let recree4KeywordArray = ['共同エンジニアリング', 'JAGフィールド', '工事監理', '専任技術者', 'コンストラクションマネジメント', '管理技術者', '概略設計', 'リフォーム工事', 'W造', '木造住宅', '戸建て住宅', 'マンション工事', 'ビル工事', '杭工事', '鋼構造物', '法面工事', '港湾工事', '現場監督', 'ゼネコン', '現場管理', '土木', '現場代理', 'ウィルオブ・コンストラクション', 'ワールドコーポレーション', 'アーキ・ジャパン', 'テクノプロ・コンストラクション', 'イーフラッグ', 'SUGUNI', 'コプロ・エンジニアード', '夢真', 'アクトエンジニアリング', 'スタッフ・アクティオ', 'ＵＴコンストラクション', 'サイマリーディング', '意匠設計', '主任技術者', '監理技術者', 'ハウスメーカー', 'RCCM', '内装設計', '構造設計', '設備設計', '設計士', '設計監理', '管工事', '改修工事', '修繕工事', '改築工事', '電験', '大規模修繕', '高松建設', 'ヤマギシリフォーム工業', 'カシワバラコーポレーション', 'メルディア', 'フクダアンドパートナーズ', 'ケイアイスター不動産', '一建設', '塩浜工業', 'ホークワン', '北野建設', '生和コーポレーション', 'サブコン', '電気工事士', '日建学院', 'RC造', 'PC造', 'S造', '軽量鉄骨造', '木質フレーム構造', '地盤改良工事', 'プレキャストコンクリート工法', 'システム建築工法', 'ツーバイフォー工法', 'トンネル工法', '地中構造物工法', '逆打ち工法', 'スリップフォーム工法', 'クライミングフォーム工法', 'トンネル工事', '河川工事', '上下水道工事', '海岸工事', '地滑り防止工事', '災害復旧工事', '地下構造物の建設', '施工技士', '現場監理', '工事管理', '建築士', '現場所長', '現場主任', '工事主任', '建設コンサルタント', '建築コンサルタント', '住宅リフォーム', '建設マネジメント']
          if (basicData.age >= 31 && basicData.age <= 55) {
            if (this.addressCheck(basicData, recree4AddressArray)) {
              if (this.keywordCheckRirekisho(formatData, recree345NotKeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, recree345NotKeywordArray)) {
                isRecree_4 = false
              } else if (this.keywordCheckRirekisho(formatData, recree3KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, recree3KeywordArray)) {
                isRecree_4 = true
              }
            }
          }

          let recree5AddressArray = ['青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '三重県', '滋賀県', '鳥取県', '島根県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県']
          let recree5KeywordArray = ['共同エンジニアリング', 'JAGフィールド', '工事監理', '専任技術者', 'コンストラクションマネジメント', '管理技術者', '概略設計', 'リフォーム工事', 'W造', '木造住宅', '戸建て住宅', 'マンション工事', 'ビル工事', '杭工事', '鋼構造物', '法面工事', '港湾工事', '現場監督', 'ゼネコン', '現場管理', '土木', '現場代理', 'ウィルオブ・コンストラクション', 'ワールドコーポレーション', 'アーキ・ジャパン', 'テクノプロ・コンストラクション', 'イーフラッグ', 'SUGUNI', 'コプロ・エンジニアード', '夢真', 'アクトエンジニアリング', 'スタッフ・アクティオ', 'ＵＴコンストラクション', 'サイマリーディング', '意匠設計', '主任技術者', '監理技術者', 'ハウスメーカー', 'RCCM', '内装設計', '構造設計', '設備設計', '設計士', '設計監理', '管工事', '改修工事', '修繕工事', '改築工事', '電験', '大規模修繕', '高松建設', 'ヤマギシリフォーム工業', 'カシワバラコーポレーション', 'メルディア', 'フクダアンドパートナーズ', 'ケイアイスター不動産', '一建設', '塩浜工業', 'ホークワン', '北野建設', '生和コーポレーション', 'サブコン', '電気工事士', '日建学院', 'RC造', 'PC造', 'S造', '軽量鉄骨造', '木質フレーム構造', '地盤改良工事', 'プレキャストコンクリート工法', 'システム建築工法', 'ツーバイフォー工法', 'トンネル工法', '地中構造物工法', '逆打ち工法', 'スリップフォーム工法', 'クライミングフォーム工法', 'トンネル工事', '河川工事', '上下水道工事', '海岸工事', '地滑り防止工事', '災害復旧工事', '地下構造物の建設', '施工技士', '現場監理', '工事管理', '建築士', '現場所長', '現場主任', '工事主任', '建設コンサルタント', '建築コンサルタント', '住宅リフォーム', '建設マネジメント']
          if (basicData.age >= 20 && basicData.age <= 35) {
            if (this.addressCheck(basicData, recree5AddressArray)) {
              if (this.keywordCheckRirekisho(formatData, recree345NotKeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, recree345NotKeywordArray)) {
                isRecree_5 = false
              } else if (this.keywordCheckRirekisho(formatData, recree3KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, recree3KeywordArray)) {
                isRecree_5 = true
              }
            }
          }


          if (formatData.gradeYear == 26) {
            if (basicData.email &&
              basicData.tel1 &&
              basicData.tel2 &&
              basicData.tel3 &&
              basicData.lastName &&
              basicData.firstName) {
              let isNeocareerAddressArray2 = ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '山梨県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県']
              if (true) {
                if (basicData.age <= 25 && !formatData.foreignStudent) {
                  isNeocareer_1 = true
                  isHitotechNeocareer_1 = false
                }
              }
            }
          }
          if (basicData.email &&
            basicData.tel1 &&
            basicData.tel2 &&
            basicData.tel3 &&
            basicData.lastName &&
            basicData.firstName) {
            let isNeocareerAddressArray2 = ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '山梨県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県']
            if (this.addressCheck(basicData, isNeocareerAddressArray2)) {
              if (basicData.age <= 25) {
                if (this.keywordCheck(formatId, formatData, '2025年　卒業見込') || this.keywordCheck(formatId, formatData, '2025年 卒業見込')) {
                  isNeocareer_2 = true
                }
              }
            }
          }
          let isNeocareer3AddressArray = ['東京都', '千葉県', '埼玉県', '神奈川県']
          if (this.addressCheck(basicData, isNeocareer3AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 50) {
              if (this.keywordCheck(formatId, formatData, '保育士')) {
                isNeocareer_3 = true
              }
            }
          }
          let isNeocareer4AddressArray = ['北海道', '青森県', '岩手県', '宮城県', '福島県', '秋田県', '山形県', '茨城県', '栃木県', '群県馬', '長野県', '山梨県', '静岡県', '愛知県', '岐阜県', '新潟県', '富山県', '石川県', '福井県', '滋賀県', '京都府', '大阪府', '奈良県', '三重県', '和歌山県', '兵庫県', '岡山県', '広島県', '山口県', '島根県', '鳥取県', '香川県', '愛媛県', '高知県', '徳島県', '福岡県', '大分県', '宮崎県', '鹿児島県', '熊本県', '佐賀県', '長崎県', '沖縄県']
          if (this.addressCheck(basicData, isNeocareer4AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 50) {
              if (this.keywordCheck(formatId, formatData, '保育士')) {
                isNeocareer_4 = true
              }
            }
          }

          let isMedley_Link_5KeywordArray = ['看護師']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_5KeywordArray)) {
            isMedley_Link_5 = true
          }
          let isMedley_Link_6KeywordArray = ['介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_6KeywordArray)) {
            isMedley_Link_6 = true
          }
          let isMedley_Link_7KeywordArray = ['保育士']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_7KeywordArray)) {
            isMedley_Link_7 = true
          }
          let isMedley_Link_8KeywordArray = ['栄養士']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_8KeywordArray)) {
            isMedley_Link_8 = true
          }
          let isMedley_Link_9KeywordArray = ['作業療法士']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_9KeywordArray)) {
            isMedley_Link_9 = true
          }
          let isMedley_Link_10KeywordArray = ['理学療法士']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_10KeywordArray)) {
            isMedley_Link_10 = true
          }
          let isMedley_Link_11KeywordArray = ['臨床工学技士']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_11KeywordArray)) {
            isMedley_Link_11 = true
          }
          let isMedley_Link_12KeywordArray = ['臨床検査技師']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_12KeywordArray)) {
            isMedley_Link_12 = true
          }
          let isMedley_Link_13KeywordArray = ['診療放射線技師']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_13KeywordArray)) {
            isMedley_Link_13 = true
          }
          let isMedley_Link_14KeywordArray = ['言語聴覚士']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_14KeywordArray)) {
            isMedley_Link_14 = true
          }
          let isMedley_Link_15KeywordArray = ['視能訓練士']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_15KeywordArray)) {
            isMedley_Link_15 = true
          }
          let isMedley_Link_16KeywordArray = ['歯科衛生士']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_16KeywordArray)) {
            isMedley_Link_16 = true
          }
          let isMedley_Link_17KeywordArray = ['歯科助手']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_17KeywordArray)) {
            isMedley_Link_17 = true
          }
          let isMedley_Link_18KeywordArray = ['看護助手']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_18KeywordArray)) {
            isMedley_Link_18 = true
          }
          let isMedley_Link_19KeywordArray = ['美容師']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_19KeywordArray)) {
            isMedley_Link_19 = true
          }
          let isMedley_Link_20KeywordArray = ['柔道整復師']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_20KeywordArray)) {
            isMedley_Link_20 = true
          }
          let isMedley_Link_21KeywordArray = ['児童指導員']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_21KeywordArray)) {
            isMedley_Link_21 = true
          }
          let isMedley_Link_22KeywordArray = ['医療事務']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_22KeywordArray)) {
            isMedley_Link_22 = true
          }





          let isPleiades_9KeywordArray = ['保育士']
          if (this.keywordCheckRirekisho(formatData, isPleiades_9KeywordArray)) {
            if (basicData.age >= 51 && basicData.age <= 60) {
              isPleiades_9 = true
            }
          }

          let isPleiades_1KeywordArray = ['児童発達支援管理責任者', '児童支援員', '学童指導員', '放課後等デイサービス']
          if (this.keywordCheckRirekisho(formatData, isPleiades_1KeywordArray)) {
            if (basicData.age >= 30 && basicData.age <= 59) {
              isPleiades_1 = true
            }
          }
          let isPleiades_2KeywordArray = ['栄養士']
          let isPleiades_2AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府']
          // if (this.addressCheck(basicData, isPleiades_2AddressArray) || true) {
          if (true) {
            if (this.keywordCheckRirekisho(formatData, isPleiades_2KeywordArray) ||
              this.keywordCheckShokumukeirekisho(formatData, isPleiades_2KeywordArray)) {
              if (basicData.age >= 23 && basicData.age <= 54) {
                isPleiades_2 = true
              }
            }
          }
          let isPleiades_3KeywordArray = ['パティシエ', 'パン職人', 'ブーランジェ', '鮮魚加工', '精肉加工']
          let isPleiades_3AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府', '兵庫県', '京都府']
          if (this.addressCheck(basicData, isPleiades_3AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isPleiades_3KeywordArray)) {
              if (basicData.age >= 23 && basicData.age <= 45) {
                isPleiades_3 = true
              }
            }
          }
          let isPleiades_4KeywordArray = ['建設機械整備技能士']
          if (true) {
            if (this.keywordCheckRirekisho(formatData, isPleiades_4KeywordArray)) {
              if (basicData.age >= 23 && basicData.age <= 45) {
                isPleiades_4 = true
              }
            }
          }
          let isPleiades_5KeywordArray = ['設備管理', '電気保安', 'ビルメンテナンス']
          let isPleiades_5AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府', '兵庫県', '京都府', '奈良県', '福岡県', '愛知県']
          if (this.addressCheck(basicData, isPleiades_5AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isPleiades_5KeywordArray)) {
              if (basicData.age >= 23 && basicData.age <= 45) {
                isPleiades_5 = true
              }
            }
          }
          let isPleiades_6KeywordArray = ['ゼネコン', 'サブコン', '現場代理人', '現場監督']
          let isPleiades_6AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府', '兵庫県', '京都府', '奈良県', '福岡県', '愛知県']
          if (this.addressCheck(basicData, isPleiades_6AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isPleiades_6KeywordArray)) {
              if (basicData.age >= 23 && basicData.age <= 45) {
                isPleiades_6 = true
              }
            }
          }
          let isPleiades_7KeywordArray = ['設備保全', 'ビル管理', '建築物環境衛生管理技術者']
          let isPleiades_7AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府', '兵庫県', '京都府', '奈良県', '福岡県', '愛知県']
          if (this.addressCheck(basicData, isPleiades_7AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isPleiades_7KeywordArray)) {
              if (basicData.age >= 23 && basicData.age <= 45) {
                isPleiades_7 = true
              }
            }
          }
          let isPleiades_8KeywordArray = ['大型自動車', '中型自動車']
          let isPleiades_8AddressArray = ['大阪府']
          if (this.addressCheck(basicData, isPleiades_8AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isPleiades_8KeywordArray)) {
              if (basicData.age >= 20 && basicData.age <= 49) {
                isPleiades_8 = true
              }
            }
          }




          let isPeacekaigo_1KeywordArray = ['ヘルパー2級', 'ヘルパー1級', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '精神保険福祉士', '介護支援専門員', '主任介護支援専門員']
          let isPeacekaigo_1AddressArray = ['北海道', '大阪府', '奈良県', '兵庫県', '宮城県', '京都府']


          let isPeacekaigo_2KeywordArray = ['介護福祉士', '実務者研修', '初任者研修']
          let isPeacekaigo_2AddressArray = ['北海道', '青森県', '岩手県', '宮城県', '新潟県', '大阪府', '京都府', '兵庫県', '奈良県']
          // if (this.addressCheck(basicData, isPeacekaigo_2AddressArray)) {
          //   if (this.keywordCheckRirekisho(formatData, isPeacekaigo_2KeywordArray)) {
          //     isPeacekaigo_2 = true
          //   }
          // }
          if (this.addressCheck(basicData, isPeacekaigo_2AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isPeacekaigo_2KeywordArray)) {
              isPeacekaigo_2 = true
            }
          }
          let isPeacekaigo_3KeywordArray = ['ヘルパー2級', 'ヘルパー1級', '初任者研修', '実務者研修', '介護福祉士', '介護支援専門員', '主任介護支援専門員']
          let isPeacekaigo_3AddressArray = ['大阪府']

          let isPeacekaigo_4KeywordArray = ['准看護師', '正看護師']
          let isPeacekaigo_5KeywordArray = ['正看護師']
          // let isPeacekaigo_4AddressArray = ['大阪府']
          if (true) {
            if (this.keywordCheckRirekisho(formatData, isPeacekaigo_4KeywordArray)) {
              isPeacekaigo_4 = true
            }
          }
          if (true) {
            if (this.keywordCheckRirekisho(formatData, isPeacekaigo_5KeywordArray)) {
              isPeacekaigo_5 = true
            }
          }

          let isPleiades_10KeywordArray = ['保育士']
          let isPleiades_10AddressArray = ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '新潟県', '富山県', '石川県', '福井県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県']
          if (this.addressCheck(basicData, isPleiades_10AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 49) {
              if (this.keywordCheckRirekisho(formatData, isPleiades_10KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isPleiades_10KeywordArray)) {
                isPleiades_10 = true
              }
            }
          }
          let isPleiades_18KeywordArray = ['保育士']
          let isPleiades_18AddressArray = ['茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県']
          if (this.addressCheck(basicData, isPleiades_18AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 49) {
              if (this.keywordCheckRirekisho(formatData, isPleiades_18KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isPleiades_18KeywordArray)) {
                isPleiades_18 = true
              }
            }
          }
          let isPleiades_11KeywordArray = ['施工管理']
          if (basicData.age >= 20 && basicData.age <= 65) {
            if (this.keywordCheckShokumukeirekisho(formatData, isPleiades_11KeywordArray)) {
              isPleiades_11 = true
            }
          }
          let isPleiades_12KeywordArray = ['自動車整備士']
          if (basicData.age >= 20 && basicData.age <= 65) {
            if (this.keywordCheckShokumukeirekisho(formatData, isPleiades_12KeywordArray)) {
              isPleiades_12 = true
            }
          }
          let isPleiades_13KeywordArray = ['自動車整備工']
          if (basicData.age >= 20 && basicData.age <= 65) {
            if (this.keywordCheckShokumukeirekisho(formatData, isPleiades_13KeywordArray)) {
              isPleiades_13 = true
            }
          }
          let isPleiades_14KeywordArray = ['電気主任技術者']
          if (basicData.age >= 20 && basicData.age <= 65) {
            if (this.keywordCheckShokumukeirekisho(formatData, isPleiades_14KeywordArray)) {
              isPleiades_14 = true
            }
          }
          let isPleiades_15KeywordArray = ['管理技術者']
          if (basicData.age >= 20 && basicData.age <= 65) {
            if (this.keywordCheckShokumukeirekisho(formatData, isPleiades_15KeywordArray)) {
              isPleiades_15 = true
            }
          }
          let isPleiades_16KeywordArray = ['電気工事']
          if (basicData.age >= 20 && basicData.age <= 65) {
            if (this.keywordCheckShokumukeirekisho(formatData, isPleiades_16KeywordArray)) {
              isPleiades_16 = true
            }
          }
          let isPleiades_17KeywordArray = ['現場監督']
          if (basicData.age >= 20 && basicData.age <= 65) {
            if (this.keywordCheckShokumukeirekisho(formatData, isPleiades_17KeywordArray)) {
              isPleiades_17 = true
            }
          }


          let krasys1AddressArray = ['東京都', '千葉県', '神奈川県', '埼玉県']

          // let krasys2AddressArray = ['東京都', '千葉県', '神奈川県', '埼玉県']
          if (true) {
            if (basicData.age >= 23 && basicData.age <= 55) {
              if (this.keywordCheck(formatId, formatData, '薬剤師')) {
                isKrasys_2 = true
              }
            }
          }
          if (true) {
            if (basicData.age >= 23 && basicData.age <= 59) {
              if (this.keywordCheckOnlyLicense(formatId, formatData, '薬剤師')
                || this.keywordCheckShokumukeirekishoOnlyLicense(formatData, '薬剤師')) {
                isPharmacareer_1 = true
              }
            }
          }


          let isYagishSaiyo1 = false
          let isYagishSaiyo2 = false
          let isYagish_8 = false

          if (this.keywordCheck3(formatData, '営業') || this.keywordCheck3(formatData, '販売')) {
            isYagishSaiyo1 = false
          }
          if (this.keywordCheck3(formatData, '分析') || this.keywordCheck3(formatData, 'ディレクター') || this.keywordCheck3(formatData, 'GA') || this.keywordCheck3(formatData, 'グーグルアナリティクス') || this.keywordCheck3(formatData, 'Googleアナリティクス') || this.keywordCheck3(formatData, 'UI・UX設計') || this.keywordCheck3(formatData, 'ユーザーテスト') || this.keywordCheck3(formatData, 'SEO')) {
            isYagishSaiyo2 = false
          }

          if (formatData.gradeYear == 24) {
            if (formatData.foreignStudent) {
              isYagish = false
            }
          }
          if (formatData.foreignStudent) {
            isYagish_8 = true
          }


          // let isKikkakeagent_1KeywordArray = ['Java', 'PHP', 'C#', 'プロジェクトマネージャー', 'PM', 'プロジェクトリーダー', 'システムアーキテクト', 'システムエンジニア', 'バックエンドエンジニア', 'インフラエンジニア', 'フロントエンドエンジニア', 'AWS', 'Azure', 'GCP', 'Linux']
          let isKikkakeagent_1KeywordArray = ['Java', 'PHP', 'C#', 'システムアーキテクト', 'システムエンジニア', 'バックエンドエンジニア', 'インフラエンジニア', 'フロントエンドエンジニア', 'GCP', 'Linux', 'TypeScript', 'Python', 'Go言語', 'COBOL', 'Angular', 'Laravel', 'React', 'Vue.js', 'Apache', 'Nginx', 'MariaDB', 'MongoDB', 'MySQL', 'Postgre', 'SES']
          let isKikkakeagent_1AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府', '愛知県', '福岡県']
          if (this.addressCheck(basicData, isKikkakeagent_1AddressArray)) {
            if (basicData.age >= 24 && basicData.age <= 40) {
              if (this.keywordCheckRirekisho(formatData, isKikkakeagent_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isKikkakeagent_1KeywordArray)) {
                isKikkakeagent_1 = true
              }
            }
          }
          if (formatId == "engineer_shokumukeirekisho") {
            isKikkakeagent_1 = true
          }

          let isHuproinc_1KeywordArray = ['経理', '法務', '人事', '税理士', '税務', '社労士', '社会保険労務士', '公認会計士', '労務', '財務', 'CFO', '経営管理', '簿記']
          let isHuproinc_1AddressArray = ['東京都']
          if (this.addressCheck(basicData, isHuproinc_1AddressArray)) {
            if (basicData.age >= 25 && basicData.age <= 45) {
              if (this.keywordCheckRirekisho(formatData, isHuproinc_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isHuproinc_1KeywordArray)) {
                isHuproinc_1 = true
              }
            }
          }

          let isStarlabo_1KeywordArray = ['看護師']
          let isStarlabo_1AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '茨城県', '栃木県', '群馬県']
          if (this.addressCheck(basicData, isStarlabo_1AddressArray)) {
            if (basicData.age >= 25 && basicData.age <= 55) {
              if (this.keywordCheckRirekisho(formatData, isStarlabo_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isStarlabo_1KeywordArray)) {
                isStarlabo_1 = true
              }
            }
          }

          let isStarlabo_2KeywordArray = ['施工管理']
          let isStarlabo_2AddressArray = ['東京都', '埼玉県', '千葉県', '神奈川県', '愛知県', '大阪府', '福岡県']
          if (this.addressCheck(basicData, isStarlabo_2AddressArray)) {
            if (basicData.age >= 30 && basicData.age <= 45) {
              if (this.keywordCheckRirekisho(formatData, isStarlabo_2KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isStarlabo_2KeywordArray)) {
                isStarlabo_2 = true
              }
            }
          }


          if (this.keywordCheck(formatId, formatData, '薬剤師')) {
            if (basicData.age >= 23 && basicData.age <= 50) {
              isRecruitMc1 = true
            }
          }
          let recruitMc2NotKeywordArray = ['獣', '歯科']
          if (this.keywordCheck(formatId, formatData, '医師免許')) {
            if (basicData.age >= 23 && basicData.age <= 65) {
              isRecruitMc2 = true
            }
            if (this.keywordCheckRirekisho(formatData, recruitMc2NotKeywordArray)) {
              isRecruitMc2 = false
            }
            if (this.keywordCheckShokumukeirekisho(formatData, recruitMc2NotKeywordArray)) {
              isRecruitMc2 = false
            }
          }


          for (let val in request_data) {
            // console.error(request_data[val].client_id)
            if (request_data[val].client_id == 'system_shared_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isSystemShared4 = false
            }
            if (request_data[val].client_id == 'system_shared_mail' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isSystemShared5 = false
            }
            if (request_data[val].client_id == 'system_shared_mail' &&
              request_data[val].permission_type == 6 &&
              !request_data[val].request_able) {
              isSystemShared6 = false
            }
            if (request_data[val].client_id == 'system_shared_mail' &&
              request_data[val].permission_type == 8 &&
              !request_data[val].request_able) {
              isSystemShared8 = false
            }
            if (request_data[val].client_id == 'system_shared_mail' &&
              request_data[val].permission_type == 9 &&
              !request_data[val].request_able) {
              isSystemShared9 = false
            }
            if (request_data[val].client_id == 'system_shared_mail' &&
              request_data[val].permission_type == 10 &&
              !request_data[val].request_able) {
              isSystemShared10 = false
            }
            if (request_data[val].client_id == 'miraiyu_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isMiraiyu_3 = false
            }
            if (request_data[val].client_id == 'miraiyu_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isMiraiyu_4 = false
            }
            if (request_data[val].client_id == 'roxx_api' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isRoxx2 = false
            }
            if (request_data[val].client_id == 'roxx_api' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isRoxx = false
            }
            if (request_data[val].client_id == 'jobs919_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isJob919_1 = false
            }
            if (request_data[val].client_id == 'jobs919_mail' &&
              request_data[val].permission_type == 7 &&
              !request_data[val].request_able) {
              isJob919_7 = false
            }
            if (request_data[val].client_id == 'jobs919_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isJob919_2 = false
            }
            if (request_data[val].client_id == 'jobs919_mail' &&
              request_data[val].permission_type == 8 &&
              !request_data[val].request_able) {
              isJob919_8 = false
            }
            if (request_data[val].client_id == 'jobs919_mail' &&
              request_data[val].permission_type == 9 &&
              !request_data[val].request_able) {
              isJob919_9 = false
            }
            if (request_data[val].client_id == 'jobs919_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isJob919_3 = false
            }
            if (request_data[val].client_id == 'jobs919_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isJob919_4 = false
            }
            if (request_data[val].client_id == 'jobs919_mail' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isJob919_5 = false
            }
            if (request_data[val].client_id == 'jobs919_mail' &&
              request_data[val].permission_type == 6 &&
              !request_data[val].request_able) {
              isJob919_6 = false
            }


            if (request_data[val].client_id == 'persolinnovation_admin' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isPersolinnovation_1 = false
            }
            if (request_data[val].client_id == 'persolinnovation_admin' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isPersolinnovation_2 = false
            }

            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isHrcareer_1 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isHrcareer_2 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isHrcareer_3 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isHrcareer_4 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isHrcareer_5 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 6 &&
              !request_data[val].request_able) {
              isHrcareer_6 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 7 &&
              !request_data[val].request_able) {
              isHrcareer_7 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 8 &&
              !request_data[val].request_able) {
              isHrcareer_8 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 9 &&
              !request_data[val].request_able) {
              isHrcareer_9 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 10 &&
              !request_data[val].request_able) {
              isHrcareer_10 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 13 &&
              !request_data[val].request_able) {
              isHrcareer_13 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 14 &&
              !request_data[val].request_able) {
              isHrcareer_14 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 11 &&
              !request_data[val].request_able) {
              isHrcareer_11 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 12 &&
              !request_data[val].request_able) {
              isHrcareer_12 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 15 &&
              !request_data[val].request_able) {
              isHrcareer_15 = false
            }
            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isMedley1 = false
              isMedley2 = false
              isMedley3 = false
              isMedley4 = false
              isMedley5 = false
              isMedley6 = false
              isMedley7 = false
              isMedley8 = false
              isMedley9 = false
              isMedley10 = false
            }
            if (request_data[val].client_id == 'roxx_api' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isRoxx3 = false
            }
            if (request_data[val].client_id == 'roxx_api' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isRoxx_4 = false
            }
            if (request_data[val].client_id == 'hitotech_admin' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isHitotech_1 = false
            }
            if (request_data[val].client_id == 'hitotech_admin' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isHitotech_2 = false
            }
            if (request_data[val].client_id == 'hitotech_admin' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isHitotech_3 = false
            }
            if (request_data[val].client_id == 'hitotech_admin' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isHitotech_4 = false
            }
            if (request_data[val].client_id == 'careerdraft_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isCareerdraft_1 = false
            }
            if (request_data[val].client_id == 'neocareer_admin' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isNeocareer_1 = false
            }
            if (request_data[val].client_id == 'neocareer_admin' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isHitotechNeocareer_1 = false
            }
            if (request_data[val].client_id == 'neocareer_admin' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isHitotechNeocareer_1 = false
            }
            if (request_data[val].client_id == 'hitotech_admin' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isHitotechNeocareer_1 = false
            }

            if (request_data[val].client_id == 'neocareer_admin' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isNeocareer_2 = false
            }
            if (request_data[val].client_id == 'hitoshia_admin' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isNeocareer_3 = false
            }
            if (request_data[val].client_id == 'hitoshia_admin' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isNeocareer_4 = false
            }

            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isPleiades_1 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isPleiades_2 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isPleiades_3 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isPleiades_4 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isPleiades_5 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 6 &&
              !request_data[val].request_able) {
              isPleiades_6 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 7 &&
              !request_data[val].request_able) {
              isPleiades_7 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 8 &&
              !request_data[val].request_able) {
              isPleiades_8 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 9 &&
              !request_data[val].request_able) {
              isPleiades_9 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 10 &&
              !request_data[val].request_able) {
              isPleiades_10 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 18 &&
              !request_data[val].request_able) {
              isPleiades_18 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 11 &&
              !request_data[val].request_able) {
              isPleiades_11 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 12 &&
              !request_data[val].request_able) {
              isPleiades_12 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 13 &&
              !request_data[val].request_able) {
              isPleiades_13 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 14 &&
              !request_data[val].request_able) {
              isPleiades_14 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 15 &&
              !request_data[val].request_able) {
              isPleiades_15 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 16 &&
              !request_data[val].request_able) {
              isPleiades_16 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 17 &&
              !request_data[val].request_able) {
              isPleiades_17 = false
            }

            if (request_data[val].client_id == 'peacekaigo_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isPeacekaigo_2 = false
            }

            if (request_data[val].client_id == 'peacekaigo_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isPeacekaigo_4 = false
            }
            if (request_data[val].client_id == 'peacekaigo_mail' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isPeacekaigo_5 = false
            }
            if (request_data[val].client_id == 'kirara_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isKirara = false
            }
            if (request_data[val].client_id == 'tryt_api' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isTryt = false
            }
            if (request_data[val].client_id == 'yagish_link' &&
              request_data[val].permission_type == 7 &&
              !request_data[val].request_able) {
              isYagish = false
            }
            if (request_data[val].client_id == 'yagish_admin' &&
              request_data[val].permission_type == 8 &&
              !request_data[val].request_able) {
              isYagish_8 = false
            }
            if (request_data[val].client_id == 'reastage_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isReastage_1 = false
            }
            if (request_data[val].client_id == 'mynavi_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isMynavi_1 = false
            }

            if (request_data[val].client_id == 'kikkakeagent_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isKikkakeagent_1 = false
            }
            if (request_data[val].client_id == 'huproinc_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isHuproinc_1 = false
            }
            if (request_data[val].client_id == 'starlabo_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isStarlabo_1 = false
            }
            if (request_data[val].client_id == 'starlabo_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isStarlabo_2 = false
            }
            if (request_data[val].client_id == 'recruit_mc_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isRecruitMc1 = false
            }

            if (request_data[val].client_id == 'krasys_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isKrasys_2 = false
            }
            if (request_data[val].client_id == 'pharmacareer_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isPharmacareer_1 = false
            }
            if (request_data[val].client_id == 'recruit_mc_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isRecruitMc2 = false
            }

            if (request_data[val].client_id == 'asiro_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isAsiro_1 = false
            }
            if (request_data[val].client_id == 'asiro_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isAsiro_2 = false
            }
            if (request_data[val].client_id == 'asiro_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isAsiro_3 = false
            }
            if (request_data[val].client_id == 'asiro_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isAsiro_4 = false
            }
            if (request_data[val].client_id == 'asiro_mail' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isAsiro_5 = false
            }
            if (request_data[val].client_id == 'asiro_mail' &&
              request_data[val].permission_type == 6 &&
              !request_data[val].request_able) {
              isAsiro_6 = false
            }
            if (request_data[val].client_id == 'capla_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isCapla_1 = false
            }
            if (request_data[val].client_id == 'capla_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isCapla_2 = false
            }
            if (request_data[val].client_id == 'bridge_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isBridge_1 = false
            }

            if (request_data[val].client_id == 'rozas_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isRozas_1 = false
            }
            if (request_data[val].client_id == 'tunaguba_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isTunaguba_1 = false
            }
            if (request_data[val].client_id == 'dely_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isDely_1 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isXmile_1 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isXmile_2 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isXmile_3 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isXmile_4 = false
            }

            if (request_data[val].client_id == 'workport_admin' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isWorkport_1 = false
            }

            if (request_data[val].client_id == 'workport_admin' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isWorkport_4 = false
            }

            if (request_data[val].client_id == 'workport_admin' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isWorkport_2 = false
            }

            if (request_data[val].client_id == 'workport_admin' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isWorkport_3 = false
            }

            if (request_data[val].client_id == 'agrinavi_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isAgrinavi_1 = false
            }
            if (request_data[val].client_id == 'techouse_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isTechouse_1 = false
            }
            if (request_data[val].client_id == 'techouse_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isTechouse_2 = false
            }
            if (request_data[val].client_id == 'techouse_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isTechouse_3 = false
            }

            if (request_data[val].client_id == 'primalwork_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isPrimalwork_1 = false
            }
            if (request_data[val].client_id == '400f_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              is400F_1 = false
            }
            if (request_data[val].client_id == 'usenworking_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isUsenworking_1 = false
            }
            if (request_data[val].client_id == 'usenworking_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isUsenworking_2 = false
            }
            if (request_data[val].client_id == 'usenworking_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isUsenworking_3 = false
            }
            if (request_data[val].client_id == 'usenworking_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isUsenworking_4 = false
            }

            if (request_data[val].client_id == 'recree_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isRecree_1 = false
            }

            if (request_data[val].client_id == 'recree_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isRecree_2 = false
            }

            if (request_data[val].client_id == 'recree_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isRecree_3 = false
            }

            if (request_data[val].client_id == 'recree_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isRecree_4 = false
            }

            if (request_data[val].client_id == 'recree_mail' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isRecree_5 = false
            }



            if (request_data[val].client_id == 'growtrail_admin' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isArowtrail_1 = false
            }

            if (request_data[val].client_id == 'growtrail_admin' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isArowtrail_2 = false
            }

            if (request_data[val].client_id == 'growtrail_admin' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isArowtrail_3 = false
            }
            if (request_data[val].client_id == 'yagish_test_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isYagish_1 = false
            }
            if (request_data[val].client_id == 'sms_admin' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isSms_1 = false
            }
            if (request_data[val].client_id == 'sms_admin_eiyoshi' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isSms_2 = false
            }
            if (request_data[val].client_id == 'sms_admin_hoiku' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isSms_3 = false
            }
            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isMedley_Link_5 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 6 &&
              !request_data[val].request_able) {
              isMedley_Link_6 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 7 &&
              !request_data[val].request_able) {
              isMedley_Link_7 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 8 &&
              !request_data[val].request_able) {
              isMedley_Link_8 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 9 &&
              !request_data[val].request_able) {
              isMedley_Link_9 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 10 &&
              !request_data[val].request_able) {
              isMedley_Link_10 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 11 &&
              !request_data[val].request_able) {
              isMedley_Link_11 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 12 &&
              !request_data[val].request_able) {
              isMedley_Link_12 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 13 &&
              !request_data[val].request_able) {
              isMedley_Link_13 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 14 &&
              !request_data[val].request_able) {
              isMedley_Link_14 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 15 &&
              !request_data[val].request_able) {
              isMedley_Link_15 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 16 &&
              !request_data[val].request_able) {
              isMedley_Link_16 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 17 &&
              !request_data[val].request_able) {
              isMedley_Link_17 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 18 &&
              !request_data[val].request_able) {
              isMedley_Link_18 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 19 &&
              !request_data[val].request_able) {
              isMedley_Link_19 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 20 &&
              !request_data[val].request_able) {
              isMedley_Link_20 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 21 &&
              !request_data[val].request_able) {
              isMedley_Link_21 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 22 &&
              !request_data[val].request_able) {
              isMedley_Link_22 = false
            }
          }
          /*
          const clientPermissions = {
            system_shared_mail: [4, 5, 6, 8, 9, 10],
            miraiyu_mail: [3, 4],
            roxx_api: [1, 2, 3, 4],
            jobs919_mail: [1, 2, 3, 4, 5, 6, 7, 8, 9],
            problemsolving_mail: [1, 2],
            persolinnovation_admin: [1, 2],
            hrcareer_mail: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
            medley_link: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22],
            hitotech_admin: [1, 2, 3, 4],
            careerdraft_mail: [1],
            neocareer_admin: [1, 2],
            hitotech_neocareer: [1, 2, 3],
            hitoshia_admin: [3, 4],
            hoikushikyujin_mail: [1, 2],
            pleiades_mail: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
            peacekaigo_mail: [1, 2, 3, 4, 5],
            kirara_mail: [1],
            tryt_api: [2],
            yagish_link: [7],
            yagish_admin: [8],
            reastage_mail: [1],
            mynavi_mail: [1],
            recruit_mc_mail: [1, 2],
            krasys_mail: [1, 2],
            pharmacareer_mail: [1],
            asiro_mail: [1, 2, 3, 4, 5, 6],
            capla_mail: [1, 2],
            bridge_mail: [1],
            rozas_mail: [1],
            tunaguba_mail: [1],
            dely_mail: [1],
            xmile_mail: [1, 2, 3, 4],
            cellpromote_mail: [1],
            workport_admin: [1, 2, 3, 4],
            loginess_mail: [1],
            agrinavi_mail: [1, 2],
            techouse_mail: [1, 2, 3],
            f400_mail: [1],
            usenworking_mail: [1, 2, 3, 4],
            recree_mail: [1, 2, 3, 4, 5],
            growtrail_admin: [1, 2, 3],
            yagish_test_mail: [1],
            sms_admin: [1],
            sms_admin_eiyoshi: [2],
            sms_admin_hoiku: [3],
          };

          // request_data をループして `false` にする
          request_data.forEach(({ client_id, permission_type, request_able }) => {
            if (clientPermissions[client_id] && clientPermissions[client_id].includes(permission_type) && !request_able) {
              const varName = `is${client_id.replace(/_/g, "").charAt(0).toUpperCase() + client_id.slice(1)}_${permission_type}`;
              if (this[varName] !== undefined) {
                this[varName] = false;
              }
            }
          });
          */

          const nowdate3 = new Date()
          console.error(nowdate3)
          // if (isSms_1 && (formatId == "rirekisho_job_change" || formatId == "rirekisho_ai_career" ||
          //   formatId == "rirekisho_job_change2" ||
          //   formatId == "rirekisho_job_change_old" ||
          //   formatId == "rirekisho_single" ||
          //   formatId == "rirekisho_nophoto_double" ||
          //   formatId == "rirekisho_nophoto" ||
          //   formatId.includes('shokumukeirekisho'))) {
          //   this.$eventHub.$emit('open-sms-dialog', formatId, previewFormat, 1, basicData)
          // } else
          if (isYagish_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {


            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/yagish_logo_20230522.png',
              clientId: 'yagish_test_mail',
              dialogName: 'yagish-dialog',
              clientName: '株式会社Yagish',
              termurl: 'https://-',
              privacyurl: 'https://-',
              clientServiceName: '株式会社Yagish',
              subArea1: '株式会社Yagishをご紹介します！'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)
          } else if (isJob919_5 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            this.$eventHub.$emit('open-jobs919-dialog', formatId, previewFormat, 5, basicData)
          } else if (isTryt && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-tryt-dialog', formatId, previewFormat, 2)
          } else if (isSystemShared4 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-systemshared-dialog', formatId, previewFormat, 4)
          } else if (isJob919_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-jobs919-dialog', formatId, previewFormat, 1)
          } else if (isJob919_7 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-jobs919-dialog', formatId, previewFormat, 7)
          } else if (isJob919_2 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-jobs919-dialog', formatId, previewFormat, 2)
          } else if (isJob919_8 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-jobs919-dialog', formatId, previewFormat, 8)
          } else if (isJob919_9 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-jobs919-dialog', formatId, previewFormat, 9)
          } else if (isJob919_3 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-jobs919-dialog', formatId, previewFormat, 3)
          } else if (isJob919_4 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-jobs919-dialog', formatId, previewFormat, 4)
          } else if (isHrcareer_9 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 9)
          } else if (isHrcareer_10 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 10)
          } else if (isRozas_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-rozas-dialog', formatId, previewFormat, 1)
          } else if (isSms_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/sms_2_yagish_logo_20250205.png',
              clientId: 'sms_admin_eiyoshi',
              dialogName: 'sms-dialog',
              clientName: '株式会社エス･エム･エス',
              termurl: 'https://policy.bm-sms.co.jp/consumer/terms/jinzaibank-com',
              privacyurl: 'https://policy.bm-sms.co.jp/consumer/privacy/policy',
              clientServiceName: 'キャリア支援サービス'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData)

          } else if (isKrasys_2 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-krasys-dialog', formatId, previewFormat, 2)
          } else if (isKikkakeagent_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/kikkakeagent_yagish_logo_20250326.png',
              clientId: 'kikkakeagent_mail',
              dialogName: 'kikkakeagent-dialog',
              clientName: '株式会社キッカケクリエイション',
              termurl: 'https://kikkakeagent.com/terms/',
              privacyurl: 'https://kikkakecreation.com/privacy/',
              clientServiceName: 'キッカケエージェント'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)

          } else if (isHuproinc_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/huproinc_yagish_logo_20250406.png',
              clientId: 'huproinc_mail',
              dialogName: 'huproinc-dialog',
              clientName: '株式会社ヒュープロ',
              termurl: 'https://hupro-job.com/terms',
              privacyurl: 'https://hupro-job.com/privacy_policy',
              clientServiceName: 'ヒュープロ'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)

          } else if (isRecruitMc1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-recruit_mc-dialog', formatId, previewFormat, 1)
          } else if (isPharmacareer_1 && (formatId == "rerekisho_part_time" || formatId == "rirekisho_part_time2" ||
            formatId.includes('shokumukeirekisho'))) {
            this.$eventHub.$emit('open-pharmacareer-dialog', formatId, previewFormat, 1, basicData)
          } else if (isNeocareer_3 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-neocareer-dialog', formatId, previewFormat, 3, formatData.gradeYear)
          } else if (isNeocareer_4 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-neocareer-dialog', formatId, previewFormat, 4, formatData.gradeYear)
          } else if (isMedley_Link_8 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 8)
          } else if (isMedley_Link_11 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 11)
          } else if (isMedley_Link_12 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 12)
          } else if (isMedley_Link_13 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 13)
          } else if (isMedley_Link_14 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 14)
          } else if (isMedley_Link_15 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 15)
          } else if (isMedley_Link_16 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 16)
          } else if (isMedley_Link_17 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 17)
          } else if (isMedley_Link_18 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 18)
          } else if (isMedley_Link_19 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 19)
          } else if (isMedley_Link_20 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 20)
          } else if (isMedley_Link_21 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 21)
          } else if (isMedley_Link_22 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 22)
          } else if (isPleiades_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 1)
          } else if (isPleiades_9 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 9)
          } else if (isPleiades_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 2, basicData)
          } else if (isPleiades_3 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 3)
          } else if (isPleiades_4 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 4)
          } else if (isPleiades_5 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 5)
          } else if (isPleiades_6 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 6)
          } else if (isPleiades_7 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 7)
          } else if (isPleiades_8 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 8)
          } else if (isPleiades_10 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 10, basicData)
          } else if (isPleiades_18 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 18, basicData)
          } else if (isPleiades_11 && (formatId.includes('shokumukeirekisho'))) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 11, basicData)
          } else if (isPleiades_12 && (formatId.includes('shokumukeirekisho'))) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 12, basicData)
          } else if (isPleiades_13 && (formatId.includes('shokumukeirekisho'))) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 13, basicData)
          } else if (isPleiades_14 && (formatId.includes('shokumukeirekisho'))) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 14, basicData)
          } else if (isPleiades_15 && (formatId.includes('shokumukeirekisho'))) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 15, basicData)
          } else if (isPleiades_16 && (formatId.includes('shokumukeirekisho'))) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 16, basicData)
          } else if (isPleiades_17 && (formatId.includes('shokumukeirekisho'))) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 17, basicData)
          } else if (isCapla_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-capla-dialog', formatId, previewFormat, 1)
          } else if (isCapla_2 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-capla-dialog', formatId, previewFormat, 2)
          } else if (isReastage_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-reastage-dialog', formatId, previewFormat, 1)
          } else if (isJob919_6 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-jobs919-dialog', formatId, previewFormat, 6)
          } else if (isPeacekaigo_2 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-peacekaigo-dialog', formatId, previewFormat, 2, basicData)
          } else if (isHrcareer_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 1)
          } else if (isHrcareer_2 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 2)
          } else if (isHrcareer_3 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 3)
          } else if (isHrcareer_4 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 4)
          } else if (isPersolinnovation_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-persolinnovation-dialog', formatId, previewFormat, 1, basicData)
          } else if (isPersolinnovation_2 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-persolinnovation-dialog', formatId, previewFormat, 2, basicData)
          } else if (isHrcareer_5 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 5)
          } else if (isHrcareer_6 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 6)
          } else if (isHrcareer_7 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 7)
          } else if (isHrcareer_8 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 8)
          } else if (isHrcareer_13 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 13)
          } else if (isHrcareer_14 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 14)
          } else if (isHrcareer_11 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 11)
          } else if (isHrcareer_12 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 12)
          } else if (isHrcareer_15 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 15)
          } else if (isStarlabo_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/starlabo_1_yagish_logo_20250406.png',
              clientId: 'starlabo_mail',
              dialogName: 'starlabo-dialog',
              clientName: '株式会社スターラボ',
              termurl: 'https://search.eir-agent.jp/terms',
              privacyurl: 'https://search.eir-agent.jp/privacy',
              clientServiceName: '看護師転職支援サービスEIR(エイル)'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)

          } else if (isStarlabo_2 && formatId.includes('shokumukeirekisho')) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/starlabo_2_yagish_logo_20250406.png',
              clientId: 'starlabo_mail',
              dialogName: 'starlabo-dialog',
              clientName: '株式会社スターラボ',
              termurl: 'https://scout.star-labo.co.jp/terms',
              privacyurl: 'https://scout.star-labo.co.jp/policy/',
              clientServiceName: 'スターラボ'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData)

          } else if (isSms_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {


            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/sms_1_yagish_logo_20250115.jpg',
              clientId: 'sms_admin',
              dialogName: 'sms-dialog',
              clientName: 'カイゴジョブエージェント',
              termurl: 'https://www.kaigoagent.com/contents/tos.html',
              privacyurl: 'https://www.kaigoagent.com/contents/pmark.html',
              clientServiceName: 'キャリア支援サービス',
              subArea1: '介護の求人・転職ならカイゴジョブエージェント<br>電話にて非公開求人をご紹介します！'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)
          } else if (isSms_3 && this.isJobChangeShokumukeirekiFormat(formatId)) {



            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/sms_3_yagish_logo_20250205.png',
              clientId: 'sms_admin_hoiku',
              dialogName: 'sms-dialog',
              clientName: '株式会社エス･エム･エス',
              termurl: 'https://hoiku.jinzaibank.com/contents/tos.html',
              privacyurl: 'https://policy.bm-sms.co.jp/consumer/privacy/policy',
              clientServiceName: 'キャリア支援サービス'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData)

          } else if (isPeacekaigo_4 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-peacekaigo-dialog', formatId, previewFormat, 4, basicData)
          } else if (isPeacekaigo_5 && (formatId == "rerekisho_part_time" ||
            formatId == "rirekisho_part_time2")) {
            this.$eventHub.$emit('open-peacekaigo-dialog', formatId, previewFormat, 5)
          } else if (isMedley_Link_5 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 5)
          } else if (isMedley_Link_6 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 6)
          } else if (isMedley_Link_7 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 7)
          } else if (isMedley_Link_9 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 9)
          } else if (isMedley_Link_10 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 10)
          } else if (isAsiro_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-asiro-dialog', formatId, previewFormat, 1)
          } else if (isAsiro_2 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-asiro-dialog', formatId, previewFormat, 2)
          } else if (isAsiro_3 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-asiro-dialog', formatId, previewFormat, 3)
          } else if (isAsiro_4 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-asiro-dialog', formatId, previewFormat, 4)
          } else if (isAsiro_5 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-asiro-dialog', formatId, previewFormat, 5)
          } else if (isAsiro_6 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-asiro-dialog', formatId, previewFormat, 6)
          } else if (isSystemShared5 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-systemshared-dialog', formatId, previewFormat, 5)
          } else if (isSystemShared8 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-systemshared-dialog', formatId, previewFormat, 8)
          } else if (isSystemShared9 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-systemshared-dialog', formatId, previewFormat, 9)
          } else if (isSystemShared6 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-systemshared-dialog', formatId, previewFormat, 6)
          } else if (isSystemShared10 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-systemshared-dialog', formatId, previewFormat, 10)
          } else if (isBridge_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-bridge-dialog', formatId, previewFormat, 1)
          } else if (isTunaguba_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-tunaguba-dialog', formatId, previewFormat, 1)
          } else if (isDely_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-dely-dialog', formatId, previewFormat, 1)
          } else if (isXmile_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-xmile-dialog', formatId, previewFormat, 1)
          } else if (isXmile_2 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-xmile-dialog', formatId, previewFormat, 2)
          } else if (isXmile_3 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-xmile-dialog', formatId, previewFormat, 3)
          } else if (isXmile_4 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-xmile-dialog', formatId, previewFormat, 4)
          } else if (isAgrinavi_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-agrinavi-dialog', formatId, previewFormat, 1)
          } else if (isRecree_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-recree-dialog', formatId, previewFormat, 1)
          } else if (isRecree_3 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-recree-dialog', formatId, previewFormat, 3, basicData)
          } else if (isRecree_4 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-recree-dialog', formatId, previewFormat, 4, basicData)
          } else if (isRecree_5 && this.isJobChangeFormat(formatId)) {

            this.$eventHub.$emit('open-recree-dialog', formatId, previewFormat, 5, basicData)
          } else if (isPrimalwork_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/primalwork_yagish_logo_20250326.jpg',
              clientId: 'primalwork_mail',
              dialogName: 'primalwork-dialog',
              clientName: '株式会社プライマルワーク',
              termurl: 'https://primalwork.net/terms-of-service/',
              privacyurl: 'https://primalwork.net/privacy-policy/',
              clientServiceName: 'プライマルワーク'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)
          } else if (is400F_1 && this.isJobChangeFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/400f_yagish_logo_20241212.png',
              clientId: '400f_mail',
              dialogName: '400f-dialog',
              clientName: '株式会社400F',
              termurl: 'https://lpd.okane-kenko.jp/tenshoku/docs/terms.pdf',
              privacyurl: 'https://okane-kenko.jp/policies/privacy',
              clientServiceName: 'オカネコ転職'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)
          } else if (isTechouse_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-techouse-dialog', formatId, previewFormat, 1)
          } else if (isTechouse_2 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-techouse-dialog', formatId, previewFormat, 2)
          } else if (isTechouse_3 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-techouse-dialog', formatId, previewFormat, 3)
          } else if (isRoxx2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            this.$eventHub.$emit('open-roxx-dialog', formatId, previewFormat, basicData.email, 2, '', basicData)
          } else if (isRoxx && this.isJobChangeShokumukeirekiFormat(formatId)) {
            this.$eventHub.$emit('open-roxx-dialog', formatId, previewFormat, basicData.email, 1, '', basicData)
          } else if (isUsenworking_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-usenworking-dialog', formatId, previewFormat, 1)
          } else if (isUsenworking_2 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-usenworking-dialog', formatId, previewFormat, 2)
          } else if (isUsenworking_3 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-usenworking-dialog', formatId, previewFormat, 3)
          } else if (isUsenworking_4 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-usenworking-dialog', formatId, previewFormat, 4)
          } else if (isArowtrail_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-growtrail-dialog', formatId, previewFormat, 1)
          } else if (isArowtrail_2 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-growtrail-dialog', formatId, previewFormat, 2)
          } else if (isArowtrail_3 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-growtrail-dialog', formatId, previewFormat, 3)
          } else if (isRecruitMc2 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-recruit_mc-dialog', formatId, previewFormat, 2)
          } else if (isKirara && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-kirara-dialog', formatId, previewFormat)
          } else if (isSimple1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-simple-dialog', formatId, previewFormat, 1)
          } else if (isSimple2 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-simple-dialog', formatId, previewFormat, 2)
          } else if (isSimple3 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-simple-dialog', formatId, previewFormat, 3)
          } else if (isBaton && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-baton-dialog', formatId, previewFormat, 1)
          } else if (isJaic1) {
            this.$eventHub.$emit('open-jaic-dialog', formatId, previewFormat, 1)
          } else if (isJaic2) {
            this.$eventHub.$emit('open-jaic-dialog', formatId, previewFormat, 2)
          } else if (isJaic3) {
            this.$eventHub.$emit('open-jaic-dialog', formatId, previewFormat, 3)
          } else {
            if (isJob919_4 && (formatId == "rirekisho_job_change" || formatId == "rirekisho_ai_career" ||
              formatId == "rirekisho_job_change2" ||
              formatId == "rirekisho_job_change_old" ||
              formatId == "rirekisho_single" ||
              formatId == "rirekisho_nophoto_double" ||
              formatId == "rirekisho_nophoto")) {
              this.$eventHub.$emit('open-jobs919-dialog', formatId, previewFormat, 4)
            } else if (isRecree_2 && this.isJobChangeFormat(formatId)) {
              this.$eventHub.$emit('open-recree-dialog', formatId, previewFormat, 2, basicData)
            } else if (isBaton2 && (formatId == "rirekisho_job_change" || formatId == "rirekisho_ai_career" ||
              formatId == "rirekisho_job_change2" ||
              formatId == "rirekisho_job_change_old" ||
              formatId == "rirekisho_single" ||
              formatId == "rirekisho_nophoto_double" ||
              formatId == "rirekisho_nophoto")) {
              this.$eventHub.$emit('open-baton-dialog', formatId, previewFormat, 2)
            } else if (isSystemShared && (formatId == "rirekisho_job_change" || formatId == "rirekisho_ai_career" ||
              formatId == "rirekisho_job_change2" ||
              formatId == "rirekisho_job_change_old" ||
              formatId == "rirekisho_single" ||
              formatId == "rirekisho_nophoto_double" ||
              formatId == "rirekisho_nophoto")) {
              this.$eventHub.$emit('open-systemshared-dialog', formatId, previewFormat, 1)
            } else if (isSystemShared2 && (formatId == "rirekisho_job_change" || formatId == "rirekisho_ai_career" ||
              formatId == "rirekisho_job_change2" ||
              formatId == "rirekisho_job_change_old" ||
              formatId == "rirekisho_single" ||
              formatId == "rirekisho_nophoto_double" ||
              formatId == "rirekisho_nophoto")) {
              if (basicData.sex == 1) {
                this.$eventHub.$emit('open-systemshared-dialog', formatId, previewFormat, 2)
              } else {
                this.$eventHub.$emit('open-systemshared-dialog', formatId, previewFormat, 3)
              }
            } else if (isSystemShared3 && (formatId == "rirekisho_job_new" ||
              formatId == "rirekisho_job_new_single")) {
              if (basicData.sex == 1) {
                this.$eventHub.$emit('open-systemshared-dialog', formatId, previewFormat, 2)
              } else {
                this.$eventHub.$emit('open-systemshared-dialog', formatId, previewFormat, 3)
              }
            } else if (isAdtop && (formatId == "rirekisho_job_change" || formatId == "rirekisho_ai_career" ||
              formatId == "rirekisho_job_change2" ||
              formatId == "rirekisho_job_change_old" ||
              formatId == "rirekisho_single" ||
              formatId == "rirekisho_nophoto_double" ||
              formatId == "rirekisho_nophoto")) {
              this.$eventHub.$emit('open-adtop-dialog', formatId, previewFormat)
            } else if (isMynaviMs && (formatId == "rirekisho_job_change" || formatId == "rirekisho_ai_career" ||
              formatId == "rirekisho_job_change2" ||
              formatId == "rirekisho_job_change_old" ||
              formatId == "rirekisho_single" ||
              formatId == "rirekisho_nophoto_double" ||
              formatId == "rirekisho_nophoto")) {
              this.$eventHub.$emit('open-mynavi-ms-dialog', formatId, previewFormat)
            } else if (isJigen && (formatId == "rirekisho_job_change" || formatId == "rirekisho_ai_career" ||
              formatId == "rirekisho_job_change2" ||
              formatId == "rirekisho_job_change_old" ||
              formatId == "rirekisho_single" ||
              formatId == "rirekisho_nophoto_double" ||
              formatId == "rirekisho_nophoto")) {
              this.$eventHub.$emit('open-jigen-dialog', formatId, previewFormat, 2)
            } else if ((isMedley1 || isMedley2 || isMedley3 || isMedley4 || isMedley5 || isMedley6 || isMedley7 || isMedley8 || isMedley9 || isMedley10)
              && !(formatId == "rirekisho_job_new" || formatId == "rirekisho_job_new_single" || formatId == "internship")) {
              this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, medleyID, 0)
            } else if (isMiraiyu_3 && (formatId == "rirekisho_job_change" || formatId == "rirekisho_ai_career" ||
              formatId == "rirekisho_job_change2" ||
              formatId == "rirekisho_job_change_old" ||
              formatId == "rirekisho_single" ||
              formatId == "rirekisho_nophoto_double" ||
              formatId == "rirekisho_nophoto")) {
              this.$eventHub.$emit('open-miraiyu-dialog', formatId, previewFormat, 3)
            } else if (isMiraiyu_4 && (formatId == "rirekisho_job_change" || formatId == "rirekisho_ai_career" ||
              formatId == "rirekisho_job_change2" ||
              formatId == "rirekisho_job_change_old" ||
              formatId == "rirekisho_single" ||
              formatId == "rirekisho_nophoto_double" ||
              formatId == "rirekisho_nophoto")) {
              this.$eventHub.$emit('open-miraiyu-dialog', formatId, previewFormat, 4)
            } else if (isMynavi_1 && (formatId == "rerekisho_part_time" ||
              formatId == "rirekisho_part_time2")) {
              this.$eventHub.$emit('open-mynavi-dialog', formatId, previewFormat, 1)
            } else if (isRoxx3 && (formatId == "rirekisho_job_new" ||
              formatId == "rirekisho_job_new_single")) {
              this.$eventHub.$emit('open-roxx-dialog', formatId, previewFormat, basicData.email, 3, formatData.gradeYear)
            } else if (isWorkport_4 && (formatId.includes('shokumukeirekisho'))) {
              this.$eventHub.$emit('open-workport-dialog', formatId, previewFormat, 4, basicData)
            } else if (isWorkport_1 && (formatId.includes('shokumukeirekisho'))) {
              this.$eventHub.$emit('open-workport-dialog', formatId, previewFormat, 1, basicData)
            } else if (isWorkport_2 && (formatId.includes('shokumukeirekisho'))) {
              this.$eventHub.$emit('open-workport-dialog', formatId, previewFormat, 2, basicData)
            } else if (isWorkport_3 && (formatId.includes('shokumukeirekisho'))) {
              this.$eventHub.$emit('open-workport-dialog', formatId, previewFormat, 3, basicData)
            } else if (isRoxx_4 && (formatId == "rirekisho_job_new" ||
              formatId == "rirekisho_job_new_single")) {
              this.$eventHub.$emit('open-roxx-dialog', formatId, previewFormat, basicData.email, 4, formatData.gradeYear)
            } else if ((formatId == "rirekisho_job_new" ||
              formatId == "rirekisho_job_new_single" ||
              formatId == "internship") && isHitotechNeocareer_1) {
              this.$eventHub.$emit('open-hitotechneocareer-dialog', formatId, previewFormat, 1)
            } else if ((formatId == "rirekisho_job_new" ||
              formatId == "rirekisho_job_new_single" ||
              formatId == "internship") && isHitotech_1) {
              this.$eventHub.$emit('open-hitotech-dialog', formatId, previewFormat, 1)
            } else if ((formatId == "rirekisho_job_new" ||
              formatId == "rirekisho_job_new_single" ||
              formatId == "internship") && isHitotech_2) {
              this.$eventHub.$emit('open-hitotech-dialog', formatId, previewFormat, 2)
            } else if ((formatId == "rirekisho_job_new" ||
              formatId == "rirekisho_job_new_single" ||
              formatId == "internship") && isHitotech_3) {
              this.$eventHub.$emit('open-hitotech-dialog', formatId, previewFormat, 3)
            } else if ((formatId == "rirekisho_job_new" ||
              formatId == "rirekisho_job_new_single" ||
              formatId == "internship") && isHitotech_4) {
              this.$eventHub.$emit('open-hitotech-dialog', formatId, previewFormat, 4)
            } else if ((formatId == "rirekisho_job_new" ||
              formatId == "rirekisho_job_new_single" ||
              formatId == "internship") && isCareerdraft_1) {
              this.$eventHub.$emit('open-careerdraft-dialog', formatId, previewFormat, 1, formatData.gradeYear)
            } else if ((formatId == "rirekisho_job_new" ||
              formatId == "rirekisho_job_new_single" ||
              formatId == "internship") && isNeocareer_1) {
              this.$eventHub.$emit('open-neocareer-dialog', formatId, previewFormat, 1, formatData.gradeYear)
            } else if ((formatId == "rerekisho_part_time") && isNeocareer_2) {
              this.$eventHub.$emit('open-neocareer-dialog', formatId, previewFormat, 2, formatData.gradeYear)
            } else if ((formatId == "rirekisho_job_new" ||
              formatId == "rirekisho_job_new_single") && isYagish_8) {
              this.$eventHub.$emit('open-yagish-dialog', formatId, previewFormat, 8)
            } else {
              this.$eventHub.$emit('open-carat-dialog', formatId, previewFormat, this.checkJoblistKeyword(formatId, formatData), this.getPrefJoblist(basicData), basicData.age, 1, null, null, basicData.address1)
            }
            // if (formatId == "shokumukeirekisho") {
            //   console.error(formatData)
            //   if (isYagishSaiyo2) {
            //     this.$eventHub.$emit('open-yagish-dialog', formatId, previewFormat, 6)
            //   } else if (isYagishSaiyo1) {
            //     this.$eventHub.$emit('open-yagish-dialog', formatId, previewFormat, 5)
            //   } else {
            //     this.$eventHub.$emit('open-carat-dialog', formatId, previewFormat, this.checkJoblistKeyword(formatId, formatData), this.getPrefJoblist(basicData), basicData.age, 1, null, null, basicData.address1)
            //   }
            // }
          }
        }
      }
    })
    Vue.prototype.$globalVar = main
  }
}
export default globalVar
